import React, {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  DKIcon,
  DKLabel,
  DKInput,
  DKButton,
  Toggle,
  showAlert,
  INPUT_VIEW_DIRECTION,
  DKLine,
  DKTooltipWrapper
} from "deskera-ui-library";
import zeroState from "../../../assets/images/zero-state-default.svg";
import { fetchComponent, selectComponent } from "../../../Redux/Slices/ComponentListSlice";
import {
  CONSTANTS,
  ERRORS_COMPONENTS,
  INPUT_TYPE,
  COMPONENT_TYPE,
  COLUMN_CODES,
  VIEWPORT_SIZES,
  ERF,
} from "../../../constants/Constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchTotalBenefits, selectBenefits } from "../../../Redux/Slices/BenefitSlice";
import EmployeeListService from "../../../services/EmployeeListService";
import ic_add_white from "../../../assets/icons/ic_add_white.png";
import ic_edit from "../../../assets/icons/ic_edit.png";
import ic_delete from "../../../assets/icons/ic_delete.png";
import Utility, { deepClone, getCapitalized, setReactRef, setTabIndex } from "../../../utility/Utility";
import { CONFIG_SECTION } from "./Employee";
import { fetchEmployeeListWithoutFilter, selectEmployeeListWithoutLimit, selectTenanatData } from "../../../Redux/Slices/EmployeeListSlice";
import ic_info_warning from "../../../assets/icons/ic_info_gray.svg";
import ic_info_error from "../../../assets/icons/ic_info_error.svg";
import {
  getVariableComponentEstimationAmount,
  getCompensationInPerMonth,
  removeFirstDecimalFromInput,
  isUSCompliance,
  isBenefitEnabled,
  isIndiaCompliance,
  reverseTimezoneOffset,
  isComponentFormulaConfiguration,
  getTenantDeciamlFormattedAmount,
  scrollToError,
} from "../../../managers/common/CommonUtil";
import RightPanel from "../RightPanel";
import moment from "moment";
import ComponentGroupsService from "../../../services/ComponentGroupsService";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import { useTranslation } from "react-i18next";
import { getViewportSize } from "../../../utility/ViewportSizeUtils";
import MaskInput from "../../../SharedComponents/MaskInput/MaskInput";
import MaskInputUtil from "../../../SharedComponents/MaskInput/MaskInputUtil";
import AddComponentGroupPopup from "../../component-groups/AddComponentGroupPopup";
import ComponentAddPopup from "../../Component/ComponentAddPopup";
import AddEditBenefitsPopup from "../../benefits/AddEditBenefitsPopup";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";
import EmployeeConfigService from "../../../services/EmployeeConfigService";
import CustomSectionManager from "../../../managers/CustomSectionManager";
import EmployeeCustomSection from "./EmployeeCustomSection";

const ComponentDetails = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const isAdmin = TenantService.get(TENANT.IS_ADMIN);

  const [employeeDetails, setEmployeeDetails] = useState(
    deepClone(props.employeeData)
  );
  const [isEdit, setEdit] = useState(props.isEdit);
  const [employeeDetailedInfo, setEmployeeDetailedInfo] = useState(
    props.employeeDetailedData
  );
  const [fixedComponentColumnConfig, setFixedComponentColumnConfig] = useState(
    []
  ); //

  const [componentDefaultValues, setDefaultValues] = useState({}); //- Fixed values
  const [componentDefaultValuesVariable, setVariableDefaultValues] = useState(
    {}
  ); //- Variable values
  const [componentDefaultValuesBenefit, setBenefitDefaultValues] = useState({}); //- Benefit values
  const [fixedComponents, setFixedComponents] = useState([]);
  const [fixedDropdownOptions, setFixedDropdownOptions] = useState([]);
  const [fixedDefaultOptions, setFixedDefaultDropDownOptions] = useState([]);
  const [fixedRemainingOptions, setFixedRemainingOptions] = useState([]);
  const [fixedRemainingDefaultOptions, setFixedRemainingDefaultOptions] = useState([]);
  const [isSalaryAdvance, setSalaryAdvance] = useState(false);

  const initialSalaryAdvanceFormField = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.SALARY_ADVANCE);
  const [salaryAdvanceFormFields, setSalaryAdvanceFormFields] = useState(initialSalaryAdvanceFormField);

  //Variable Components
  const [variableComponentColumnConfig, setVariableComponentColumnConfig] =
    useState([]); //
  const [variableComponent, setVariableComponents] = useState([]);
  const [variableDropdownOptions, setVariableDropdownOptions] = useState([]);
  const [variableDefaultOptions, setVariableDefaultDropDownOptions] = useState(
    []
  );
  const [variableRemainingOptions, setVariableRemainingOptions] = useState([]);
  const [variableRemainingDefaultOptions, setVariableRemainingDefaultOptions] =
    useState([]);

  //Benefits
  const [benefitComponentColumnConfig, setBenefitComponentColumnConfig] =
    useState([]);
  const [benefitComponent, setBenefitComponents] = useState([]);
  const [benefitDropdownOptions, setBenefitDropdownOptions] = useState([]);
  const [benefitDefaultOptions, setbenefitDefaultDropDownOptions] = useState(
    []
  );
  const [benefitRemainingOptions, setBenefitRemainingOptions] = useState([]);
  const [benefitRemainingDefaultOptions, setBenefitRemainingDefaultOptions] =
    useState([]);
  //Salary Advance
  const [salaryAdvanceData, setSalaryAdvanceData] = useState({});
  const [salaryAdvanceDefaultValues, setSalaryAdvanceDefaultValues] = useState(
    {}
  );

  const componentMeta = useSelector(selectComponent); //
  const benefitsMeta = useSelector(selectBenefits);
  const tenantData = useSelector(selectTenanatData);

  const [componentGroup, setComponentGroupList] = useState([]);
  const [selectComponentGroup, setSelectComponentGroup] = useState(null);

  const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
  const maskUnmaskObservable = MaskInputUtil.subscripeToMaskUnmaskObservable(setMask);

  const [showAddComponentGroup, setShowAddComponentGroup] = useState(false);
  const [showAddFixedComponent, setShowAddFixedComponent] = useState(false);
  const [showAddVariableComponent, setShowAddVariableComponent] = useState(false);
  const [showAddBenefits, setShowAddBenefits] = useState(false);
  const employeeList = useSelector(selectEmployeeListWithoutLimit);
  const [employeeListState, setEmployeeList] = useState(employeeList)
  const [hasPermission, setPermission] = useState(
    props.isEdit ? PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT]) : PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.CREATE])
  )

  const [customSections, setCustomSections] = useState(EmployeeConfigService.getNonDefaultFieldSections(2));
  const [customSectionFieldValues, setCustomSectionFieldValues] = useState([]);
  const [hideCompensation, setHideCompensation] = useState(true);

  useEffect(() => {
    getComponentGroups();
    
    if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
      setHideCompensation(props.employeeData?.hideCompensation);
    } else {
      setHideCompensation(false)
    }
  }, []);

  useEffect(() => {
    if(Utility.isEmpty(employeeList)) {
      loadEmployee({
          customJson:{
              "orderBy.field": "updatedAt",
              "orderBy.order": "desc",
            }
      });
  }
    return () => {
      MaskInputUtil.unsubscribe(maskUnmaskObservable);
    }
  }, []);

  useEffect(() => {
    if (!isAdmin) {
        setTabIndex([ERF.ADD_EMPLOYEE]);
    }
  }, [fixedComponentColumnConfig, salaryAdvanceFormFields, variableComponentColumnConfig, benefitComponentColumnConfig]);
  useEffect(()=>{
    if(!Utility.isEmpty(employeeList)) {
        setEmployeeList(employeeList)
    }
},[employeeList])
  useEffect(() => {
    let componentsData =
      employeeDetails && employeeDetails.components
        ? deepClone(employeeDetails.components)
        : "";
        
    let fixedComponentData =
      componentMeta &&
      componentMeta.components &&
      componentMeta.components.filter((x) => !x.isVariable && x.isActive);
    EmployeeListService.getInitalOptions(
      fixedComponentData,
      fixedDropdownOptions,
      fixedDefaultOptions,
      fixedRemainingOptions,
      fixedRemainingDefaultOptions
    )
    let newFixedComponent = [];
    if(!Utility.isEmpty(fixedComponentColumnConfig)) {
      fixedComponentData.forEach(fc=>{
        if(!componentDefaultValues[fc.id]) {
          newFixedComponent.push(fc);
        }
      })
    } else {
      newFixedComponent = fixedComponentData;
    }
    EmployeeListService.getFixedDropDownOptions(
      newFixedComponent,
      fixedDropdownOptions,
      fixedDefaultOptions,
      fixedRemainingOptions,
      fixedRemainingDefaultOptions
    );
    // Fixed components => setDefaultValues setting setDefaultValues in below function edit case save Without calculation
    // componentsData to-> componentDefaultValues
    let fixedConfigDetails = 
      !Utility.isEmpty(fixedComponentColumnConfig) ? deepClone(fixedComponentColumnConfig) : (
        EmployeeListService.createFixedComponentColumnConfig(
          fixedComponentData,
          componentDefaultValues,
          componentsData,
          fixedRemainingOptions,
          fixedRemainingDefaultOptions,
          isEdit
        )
      )
      if(fixedComponentColumnConfig) {
        fixedConfigDetails = fixedConfigDetails.filter(col=>!Utility.isEmpty(col.id))
        updateColumnOptions(fixedConfigDetails, true);
      }
////////// Variable//////////////////////////
    let variableComponentData =
      componentMeta &&
      componentMeta.components &&
      componentMeta.components.filter((x) => x.isVariable && x.isActive);
    EmployeeListService.getInitalOptions(
        variableComponentData,
        variableDropdownOptions,
        variableDefaultOptions,
        variableRemainingOptions,
        variableRemainingDefaultOptions
    )
    let newVariableComponent = [];
    if(!Utility.isEmpty(variableComponentColumnConfig)) {
      variableComponentData.forEach(fc=>{
        if(!componentDefaultValuesVariable[fc.id]) {
          newVariableComponent.push(fc);
        }
      })
    } else {
      newVariableComponent = variableComponentData;
    }
    EmployeeListService.getFixedDropDownOptions(
      newVariableComponent,
      variableDropdownOptions,
      variableDefaultOptions,
      variableRemainingOptions,
      variableRemainingDefaultOptions
    );
    let variableConfigDetails =
    !Utility.isEmpty(variableComponentColumnConfig) ? deepClone(variableComponentColumnConfig) : (
      EmployeeListService.createVariableComponentColumnConfig(
        variableComponentData,
        componentDefaultValuesVariable,
        componentsData,
        variableRemainingOptions,
        variableRemainingDefaultOptions,
        isEdit
      )
    );
    if(variableComponentColumnConfig) {
      variableConfigDetails = variableConfigDetails.filter(col=>!Utility.isEmpty(col.id))
      updateColumnOptionsForVariable(variableConfigDetails, true)
    }
////////////Benefit//////////////////////
    let benefitsData =
      employeeDetailedInfo && employeeDetailedInfo.benefits
        ? deepClone(employeeDetailedInfo.benefits)
        : [];
    let benefitsComponentData =
      benefitsMeta &&
      benefitsMeta.benefits &&
      benefitsMeta.benefits.filter((x) => x.isActive);
    EmployeeListService.getInitalOptions(
      benefitsComponentData,
      benefitDropdownOptions,
      benefitDefaultOptions,
      benefitRemainingOptions,
      benefitRemainingDefaultOptions
    )
    let newBenefitsComponentData = [];
    if(!Utility.isEmpty(benefitComponentColumnConfig)) {
      benefitsComponentData.forEach(fc=>{
        if(!componentDefaultValuesBenefit[fc.benefitId]) {
          newBenefitsComponentData.push(fc);
        }
      })
    } else {
      newBenefitsComponentData = benefitsComponentData;
    }
    EmployeeListService.getFixedDropDownOptions(
      newBenefitsComponentData,
      benefitDropdownOptions,
      benefitDefaultOptions,
      benefitRemainingOptions,
      benefitRemainingDefaultOptions
    );
    let benefitConfigDetails =
    (!Utility.isEmpty(benefitComponentColumnConfig))? deepClone(benefitComponentColumnConfig): (
      EmployeeListService.createBenefitComponentColumnConfig(
        benefitsComponentData,
        componentDefaultValuesBenefit,
        benefitsData,
        benefitRemainingOptions,
        benefitRemainingDefaultOptions,
        isEdit
      )
    )
      if(benefitComponentColumnConfig) {
        benefitConfigDetails = benefitConfigDetails.filter(col=>!Utility.isEmpty(col.benefitId || col.id))
        updateColumnOptionsForBenefit(benefitConfigDetails, true)
      }
      
      /////////////////////////////////
    updateCTCValueBasedOnEffectiveSalary();
    let salaryAdvanceData = setSalaryAdvanceDataForEdit();
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
    if (monthlyCompensation) {
      monthlyCompensation = parseFloat(monthlyCompensation);
    }
    updateVariableComponentCalculation(
      variableComponentData,
      variableConfigDetails
    );
    updateFormulaAmountForAllComponent(fixedConfigDetails)
    let amount = getFixedAllowanceValueForEffectiveSalary(
      monthlyCompensation,
      fixedConfigDetails,
      variableConfigDetails
    );
    if (amount > monthlyCompensation) {
      let fixedAllowanceColumn = fixedConfigDetails.find(
        (x) =>
          x.defaultComponent && x.componentName === CONSTANTS.FIXED_ALLOWANCE
      );
      if (fixedAllowanceColumn) {
        fixedAllowanceColumn.hasErrorAmount = true;
        fixedAllowanceColumn.errMsg = ERRORS_COMPONENTS.VARIABLE;
      }
    } else {
      let fixedAllowanceColumn = fixedConfigDetails.find(
        (x) =>
          x.defaultComponent && x.componentName === CONSTANTS.FIXED_ALLOWANCE
      );
      if (fixedAllowanceColumn) {
        fixedAllowanceColumn.hasErrorAmount = false;
        fixedAllowanceColumn.errMsg = `Enter a valid ${fixedAllowanceColumn.componentName}`;
      }
    }
    setFixedComponents(fixedComponentData);
    setFixedComponentColumnConfig(fixedConfigDetails);
    setVariableComponents(variableComponentData);
    setVariableComponentColumnConfig(variableConfigDetails);
    setSalaryAdvanceData(salaryAdvanceData);
    setBenefitComponents(benefitsComponentData);
    setBenefitComponentColumnConfig(benefitConfigDetails);

    const customSectionsToUpdate = CustomSectionManager.setCustomSectionFieldValues(customSections, employeeDetails["customSectionFields"]);
    const customSectionFieldValues = CustomSectionManager.getCustomSectionFields(customSectionsToUpdate);
    setCustomSectionFieldValues(customSectionFieldValues);
  }, [componentMeta,benefitsMeta]);

  useEffect(() => {
    updatePropsValue();
  }, [
    fixedComponentColumnConfig,
    salaryAdvanceFormFields,
    variableComponentColumnConfig,
    isSalaryAdvance,
    benefitComponentColumnConfig,
    customSectionFieldValues
  ]);

  useImperativeHandle(ref, () => ({
    hightlightInvalidFields() {
      const invalidFields = [];
      if (Array.isArray(customSections)) {
        const customSectionsToUpdate = CustomSectionManager.validateCustomSections(customSections);
        customSectionsToUpdate.forEach((section) => {
          if (Array.isArray(section.fields)) {
            section.fields.forEach((field) => {
              if (field.hasError) {
                invalidFields.push(field.id);
              }
            });
          }
        });

        setCustomSections(customSectionsToUpdate);

        if(invalidFields.length > 0) {
          scrollToError(invalidFields[0]);
        }
      }
    }
  }));

  const updatePropsValue = () => {
    props.setData({
      columnConfig: {
        fixedComponents: fixedComponentColumnConfig,
        variableComponents: variableComponentColumnConfig,
        salaryAdvanceFields: salaryAdvanceFormFields,
        isSalaryAdvance: isSalaryAdvance,
        benefitComponents: benefitComponentColumnConfig,
        selectComponentGroup: selectComponentGroup,
        customSections: customSections
      },
      defaults: {
        ...componentDefaultValues,
        ...componentDefaultValuesVariable,
        ...salaryAdvanceDefaultValues,
        ...componentDefaultValuesBenefit,
        customSectionFields: customSectionFieldValues
      },
    });
  };
  const loadEmployee = async (config) => {
    try {
        EmployeeListService.apiConfig = config;
        await dispatch(fetchEmployeeListWithoutFilter());
    } catch (err) {
        console.error('Error loading employees: ', err);
    }
};
  const updateCTCValueBasedOnEffectiveSalary = () => {
    let compensationAmount = 0;
    let compensationPeriod = "";
    compensationAmount = employeeDetails.ctc ? employeeDetails.ctc : 0;
    compensationPeriod = employeeDetails.compensationPeriod
      ? employeeDetails.compensationPeriod
      : "";
    if (employeeDetails.isEffectiveSalary) {
      let effectiveCompensationsArray = employeeDetails.effectiveCompensations;
      let visibleCompensation = effectiveCompensationsArray.find(
        (x) => x.isVisible
      );
      let isEffectiveSalaryApplicable = isEffectiveSalaryApplied(
        employeeDetails.isEffectiveSalary,
        visibleCompensation
      );
      if (isEffectiveSalaryApplicable) {
        compensationAmount = visibleCompensation.compensation;
        if (compensationAmount) {
          if (typeof compensationAmount === CONSTANTS.STRING) {
            compensationAmount = parseFloat(compensationAmount);
          } else if (typeof compensationAmount === INPUT_TYPE.NUMBER) {
            compensationAmount = compensationAmount;
          }
        } else {
          compensationAmount = 0;
        }
        compensationPeriod = visibleCompensation.period;
        employeeDetails["ctc"] = compensationAmount;
        employeeDetails["compensationPeriod"] = compensationPeriod;
      }
    }
  };

  const isEffectiveSalaryApplied = (isEffectiveSalary, visibleCompensation) => {
    let effectiveDate = visibleCompensation.effectiveDate;
    if (effectiveDate != "" && isEffectiveSalary) {
      if (moment().isSameOrAfter(effectiveDate)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const getComponentGroups = async() => {
    const response = await ComponentGroupsService.getComponentGroups();
    if (response.componentGroups) {
      if (employeeDetails.componentGroup) {
        let groups = response.componentGroups;
        let ind = groups.findIndex(
          (comp) => comp.id == employeeDetails.componentGroup
        );
        if (ind != -1) {
          setSelectComponentGroup(groups[ind]);
        }
      }
      setComponentGroupList(response.componentGroups);
    }
  }

  const getFixedAllowanceValueForEffectiveSalary = (
    compensation,
    fixedDetails,
    variableDetails
  ) => {
    let amount = 0;
    let fixedComponents = deepClone(fixedDetails);
    let variableComponents = deepClone(variableDetails);
    let fixedEarning = fixedComponents.filter(
      (x) => x.componentType === CONSTANTS.EARNING
    );
    let variableEarning = variableComponents.filter(
      (x) => x.componentType === CONSTANTS.EARNING
    );
    let componentId = "";
    fixedEarning.forEach((element) => {
      let includeInCTC =
        (element.defaultComponent && element.includeInCTC) ||
        (element.componentType == COMPONENT_TYPE.EARNING &&
          element.includeInCTC)
          ? true
          : false;
      if (element.componentName != CONSTANTS.FIXED_ALLOWANCE && includeInCTC) {
        amount += parseFloat(componentDefaultValues[element.id].amount);
      } else if (
        element.defaultComponent &&
        element.componentName === CONSTANTS.FIXED_ALLOWANCE
      ) {
        componentId = element.id;
      }
    });
    variableEarning.forEach((element) => {
      let includeInCTC =
        (element.defaultComponent && element.includeInCTC) ||
        (element.componentType == COMPONENT_TYPE.EARNING &&
          element.includeInCTC)
          ? true
          : false;
      if (includeInCTC) {
        amount += parseFloat(componentDefaultValuesVariable[element.id].amount);
      }
    });
    if (compensation - amount > 0) {
      if (componentDefaultValues[componentId]) {
        let amt = parseFloat(compensation) - parseFloat(amount);
        componentDefaultValues[componentId].amount =  !isNaN(parseFloat(amt)) ? parseFloat(amt.toFixed(2)) : 0; 
      }
    }
    return !isNaN(parseFloat(amount)) ? parseFloat(amount.toFixed(2)) : 0;
  };

  const setSalaryAdvanceDataForEdit = () => {
    if (
      employeeDetailedInfo &&
      employeeDetailedInfo.salaryAdvance &&
      employeeDetailedInfo.salaryAdvance.isFinished
    ) {
      setSalaryAdvance(false);
    } else {
      setSalaryAdvance(employeeDetailedInfo.hasSalaryAdvance);
      if (employeeDetailedInfo.hasSalaryAdvance) {
        let advanceDetail = employeeDetailedInfo.salaryAdvance;
        salaryAdvanceDefaultValues["advanceDetail"] = advanceDetail;
        if (advanceDetail) {
          salaryAdvanceDefaultValues["amount"] = advanceDetail.amount;
          salaryAdvanceDefaultValues["disbursementDate"] = reverseTimezoneOffset(advanceDetail.disbursementDate);
          salaryAdvanceDefaultValues["repaymentStartDate"] = reverseTimezoneOffset(advanceDetail.repaymentStartDate);
          salaryAdvanceDefaultValues["installmentAmount"] = advanceDetail.installmentAmount;
          if (advanceDetail.unpaidAmount <= advanceDetail.installmentAmount) {
            salaryAdvanceDefaultValues["installmentAmount"] = advanceDetail.unpaidAmount;
          }
          if (
            advanceDetail.isAmountDisbursed &&
            !advanceDetail.isFinished &&
            employeeDetailedInfo.salaryAdvance.disbursementDate != ""
          ) {
            advanceDetail = {
              ...advanceDetail,
              disbursementDateMin: "",
            };
          }
          let isInstallmentInit =
            advanceDetail.paidInstallmentDetails &&
            advanceDetail.paidInstallmentDetails.length != 0
              ? true
              : false;
          advanceDetail = {
            ...advanceDetail,
            isInstallmentInit: isInstallmentInit,
          };
          advanceDetail = {
            ...advanceDetail,
            remainingInstallmentAmount: advanceDetail.unpaidAmount,
          };
        }
      }
    }
  };

  const updateVariableComponentCalculation = (
    variableComponentData,
    columnConfig
  ) => {
    if (variableComponentData && variableComponentData.length > 0) {
      variableComponentData.forEach((component, index) => {
        if (component.defaultComponent && component.name === CONSTANTS.BASIC) {
          let defaultValues = componentDefaultValuesVariable[component.id];
          let value = defaultValues ? defaultValues["variableValue"] : "";
          let selection =
            componentMeta.components &&
            componentMeta.components.filter((x) => x.id === component.id);
          if (selection && selection.length > 0) {
            let selectedComponent = deepClone(selection[0]);
            let values = (componentDefaultValuesVariable && componentDefaultValuesVariable[selectedComponent?.id]) ? componentDefaultValuesVariable[selectedComponent?.id] :{};
            values["variableValue"] = value;
            let calculationValue = 0;
            if (
              selectedComponent.componentConfig.configureAmountBasis ==
              CONSTANTS.AMOUNT_PER_DAY
            ) {
              selectedComponent.componentConfig.amountPerDay = value;
              calculationValue = value;
            } else {
              selectedComponent.componentConfig.componentPercent = value;
              calculationValue = value;
            }
            const amount =
              getVariableComponentEstimatedAmount(selectedComponent);
              values["amount"] = amount;
            if (
              selectedComponent.componentConfig.configureAmountBasis ===
              CONSTANTS.AMOUNT_PER_DAY
            ) {
              values["componentPercent"] =
                selectedComponent.componentConfig.amountPerDay;
            } else {
              values["componentPercent"] =
                selectedComponent.componentConfig.componentPercent;
            }
            if (
              isIndiaCompliance() &&
              selectedComponent.defaultComponent &&
              selectedComponent.name == CONSTANTS.BASIC
            ) {
              let ind = variableComponentData.findIndex(
                (component) =>
                  component.name == CONSTANTS.HRA && component.defaultComponent
              );
              let component = variableComponentData.filter(
                (component) =>
                  component.name === CONSTANTS.HRA && component.defaultComponent
              );
              if (ind != -1 && component && component.length > 0) {
                updateHRABasedonBasic(component[0], index);
              }
            }
            updateDependentComponent(columnConfig);
          }
        }
      });
    }
  };
  /*
  *onChange param
  *value = changed valued,
  *index = index of field,
  *object = columnConfig object,
  *fieldName = fieldName,( component ,Amount, employeeCost, employerCost),
  *section = Fixed/Variable/Salary Advance
  */
  const onChange = (value, index, object, fieldName, section) => {
    if (value && value === " ") {
      value = value.trim();
    }
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
    if (monthlyCompensation) {
      monthlyCompensation = parseFloat(monthlyCompensation);
    }
    switch (section) {
      case "Fixed":
        let columnConfig = deepClone(fixedComponentColumnConfig);
        if (fieldName === "component") {
          let column = updateSelectedColumn(value, index, columnConfig, object);
          if (value?.isFormula) {
            value = removeFirstDecimalFromInput(getAmountFromFormula(value));
            componentDefaultValues[column[index].columnCode].amount = value;
            let calculatedAmount = getFixedAllowanceValue(monthlyCompensation, column);
            if (Utility.isEmpty(value) && value !=0) {
              column[index].hasErrorAmount = true;
              column[index].errMsg = `Enter a valid ${column[index].componentName}`;
            } else if(!Utility.isEmpty(value.formula)) {
              column[index].hasErrorAmount = false;
                column[index].errMsg = `Enter a valid ${column[index].componentName}`;
            } else {
              if (calculatedAmount > monthlyCompensation) {
                column[index].hasErrorAmount = true;
                column[index].errMsg = ERRORS_COMPONENTS.VARIABLE;
              } else {
                column[index].hasErrorAmount = false;
                column[index].errMsg = `Enter a valid ${column[index].componentName}`;
              }
            }
            updateDependentComponentValues(variableComponentColumnConfig, -1);
          } else {
            let calculatedAmount = getFixedAllowanceValue(monthlyCompensation, column);
            if (calculatedAmount > monthlyCompensation) {
              column[index].hasErrorAmount = true;
              column[index].errMsg = ERRORS_COMPONENTS.VARIABLE;
            } else {
              column[index].hasErrorAmount = false;
              column[index].errMsg = `Enter a valid ${column[index].componentName}`;
            }
          }
          setFixedComponentColumnConfig(column);
        } else {
          value = removeFirstDecimalFromInput(value);
          componentDefaultValues[object.id].amount = value;
          if(isComponentFormulaConfiguration()) {
            updateAmountForFormulaComponent(object.id)
          }
          let calculatedAmount = getFixedAllowanceValue(monthlyCompensation);
          if (Utility.isEmpty(value)) {
            columnConfig[index].hasErrorAmount = true;
            columnConfig[
              index
            ].errMsg = `Enter a valid ${object.componentName}`;
          } else {
            if (calculatedAmount > monthlyCompensation) {
              columnConfig[index].hasErrorAmount = true;
              columnConfig[index].errMsg = ERRORS_COMPONENTS.VARIABLE;
            } else {
              columnConfig[index].hasErrorAmount = false;
              columnConfig[
                index
              ].errMsg = `Enter a valid ${object.componentName}`;
            }
          }
          updateDependentComponentValues(variableComponentColumnConfig,-1);
          setFixedComponentColumnConfig(columnConfig);
        }
        break;
      case "Salary Advance":
        let columnConfigSalary = deepClone(salaryAdvanceFormFields);
        if (Utility.isEmpty(value) && object.required) {
          columnConfigSalary[index].hasError = true;
        } else {
          columnConfigSalary[index].hasError = false;
        }
        switch (object.id) {
          case COLUMN_CODES.AMOUNT:
            salaryAdvanceDefaultValues[object.id] = value;
            calculateNoOfInstallment();
            break;
          case COLUMN_CODES.DISBURSEMENT_DATE:
            if (!isSelectedDateofFutureMonth(object.id, value)) {
              columnConfigSalary[index].hasError = true;
              columnConfigSalary[
                index
              ].errMsg = `Disbursement date cannot be of past month`;
              salaryAdvanceDefaultValues[object.id] = "";
            } else {
              columnConfigSalary[index].hasError = false;
              columnConfigSalary[index].errMsg = `Enter a valid ${object.name}`;
              salaryAdvanceDefaultValues[object.id] = value;
            }
            if (
              !isRepaymentDateValid(
                value,
                salaryAdvanceDefaultValues[COLUMN_CODES.REPAYMENTSTART_DATE]
              )
            ) {
              columnConfigSalary[2].hasError = true;
              columnConfigSalary[2].errMsg = `Repayment date should be greater then Disbursement date`;
              salaryAdvanceDefaultValues[COLUMN_CODES.REPAYMENTSTART_DATE] = "";
            } else {
              columnConfigSalary[2].hasError = false;
              columnConfigSalary[2].errMsg = `Enter a valid ${object.name}`;
            }
            break;
          case COLUMN_CODES.REPAYMENTSTART_DATE:
            if (
              !isRepaymentDateValid(
                salaryAdvanceDefaultValues[COLUMN_CODES.DISBURSEMENT_DATE],
                value
              )
            ) {
              columnConfigSalary[index].hasError = true;
              columnConfigSalary[
                index
              ].errMsg = `Repayment date should be greater then Disbursement date`;
              salaryAdvanceDefaultValues[object.id] = "";
            } else {
              columnConfigSalary[index].hasError = false;
              salaryAdvanceDefaultValues[object.id] = value;
            }
            break;
          case COLUMN_CODES.INSTALLMENT_AMOUNT:
            salaryAdvanceDefaultValues[object.id] = value;
            calculateNoOfInstallment();
            break;
        }
        setSalaryAdvanceFormFields(columnConfigSalary);
        break;
      case "Variable":
        if (fieldName === "component") {
          let column = updateSelectedColumnForVariable(
            value,
            index,
            variableComponentColumnConfig,
            object
          );
          let columnConfigVariable = deepClone(variableComponentColumnConfig);
          if(isComponentFormulaConfiguration()) {
            updateAmountForFormulaComponent(object.id)
          }
          let amount = getFixedAllowanceValue(monthlyCompensation);
          if (amount > monthlyCompensation) {
            columnConfigVariable[index].hasErrorVariable = true;
            checkForFormulaValidation(true)
          } else {
            columnConfigVariable[index].hasErrorVariable = false;
            checkForFormulaValidation(false)
          }
          setVariableComponentColumnConfig(columnConfigVariable);
        } else {
          if (Utility.isEmpty(value)) {
            value = 0;
          }
          let columnConfigVariable = deepClone(variableComponentColumnConfig);
          let isError = false;
          let errorMessage = "";
          if (
            (object.componentName === CONSTANTS.BASIC &&
            object.defaultComponent)
          ) {
            if (parseFloat(value) > CONSTANTS.BASIC_THRESHOLD) {
              isError = true;
              errorMessage = "Enter the percentage value between";
            }
          } else if(object.componentName === CONSTANTS.HRA) {
            if (parseFloat(value) > CONSTANTS.HRA_THRESHOLD) {
              isError = true;
              errorMessage = "Enter the percentage value between";
            }
          } else {
            if (object.isPercent) {
              if (parseFloat(value) > CONSTANTS.PERCENT_THRESHOLD) {
                isError = true;
              }
            }
          }
          if (!isError) {
            updateVariableValue(value, index, columnConfigVariable, object);
            updateDependentComponentValues(variableComponentColumnConfig,-1);
            if(isComponentFormulaConfiguration) {
              updateAmountForFormulaComponent(object.id)
            }
            let amount = getFixedAllowanceValue(monthlyCompensation);
            if (amount > monthlyCompensation) {
              columnConfigVariable[index].hasErrorVariable = true;
              columnConfigVariable[index].errMsgVariable =
                ERRORS_COMPONENTS.VARIABLE;
                checkForFormulaValidation(true)
            } else {
              columnConfigVariable[index].hasErrorVariable = false;
              checkForFormulaValidation(false)
              let fixedComponents = deepClone(fixedComponentColumnConfig)
              let ind = fixedComponents.findIndex( element => (element.defaultComponent && element.componentName === CONSTANTS.FIXED_ALLOWANCE))
              
              if(ind != -1 && fixedComponents[ind].hasErrorAmount) {
                fixedComponents[ind].hasErrorAmount = false;
                setFixedComponentColumnConfig(fixedComponents)
              }
            }
          }
          setVariableComponentColumnConfig(columnConfigVariable);
        }
        break;
      case "benefit":
        let columnConfigBenefit = deepClone(benefitComponentColumnConfig);
        if (fieldName === "component") {
          let column = updateSelectedColumnBenefit(
            value,
            index,
            columnConfigBenefit,
            object
          );
          setBenefitComponentColumnConfig(column);
        } else if (fieldName === "employeeCost") {
          value = removeFirstDecimalFromInput(value);
          componentDefaultValuesBenefit[object.id].employeeDeductionAmount =
            value;
          if (Utility.isEmpty(value)) {
            columnConfigBenefit[index].hasErrorEmployeeAmount = true;
            columnConfigBenefit[index].errMsg = `Enter a valid amount`;
          }
          setBenefitComponentColumnConfig(columnConfigBenefit);
        } else if (fieldName === "employerCost") {
          value = removeFirstDecimalFromInput(value);
          componentDefaultValuesBenefit[object.id].employerDeductionAmount =
            value;
          if (Utility.isEmpty(value)) {
            columnConfigBenefit[index].hasErrorEmployerAmount = true;
            columnConfigBenefit[index].errMsg = `Enter a valid amount`;
          }
          setBenefitComponentColumnConfig(columnConfigBenefit);
        }
    }

    props.setUserDataUpdated(true);
  };
  const checkForFormulaValidation = (value,isFromGroup) => {
    let fixedComponent = isFromGroup? deepClone(isFromGroup): deepClone(fixedComponentColumnConfig);
    fixedComponent.forEach((column,index) =>{
      let valueObj = componentDefaultValues[column.columnCode];
      if(valueObj && valueObj.component && valueObj.component.isFormula && !Utility.isEmpty(valueObj.component.formula)) {
        fixedComponent[index].hasErrorAmount = value
      }
    })
    if(!isFromGroup) {
      setFixedComponentColumnConfig(fixedComponent);
    }
    
  }
  const onChangeSelectedGroup = (
    value,
    index,
    object,
    fieldName,
    section,
    oldFixedComponentColumnConfig,
    oldVariableComponentColumnConfig,
    benefitColumnConfig
  ) => {
    if (value && value === " ") {
      value = value.trim();
    }
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
    if (monthlyCompensation) {
      monthlyCompensation = parseFloat(monthlyCompensation);
    }
    switch (section) {
      case "Fixed":
        let columnConfig = oldFixedComponentColumnConfig;
        if (fieldName === "component") {
          let column = updateSelectedColumn(value, index, columnConfig, object);
          if (value?.isFormula) {
            value = removeFirstDecimalFromInput(getAmountFromFormula(value));
            componentDefaultValues[column[index].columnCode].amount = value;
            let calculatedAmount = getFixedAllowanceValue(monthlyCompensation, column);
            if (Utility.isEmpty(value) && value !=0) {
              column[index].hasErrorAmount = true;
              column[index].errMsg = `Enter a valid ${column[index].componentName}`;
            } else if(!Utility.isEmpty(value.formula)) {
              column[index].hasErrorAmount = false;
                column[index].errMsg = `Enter a valid ${column[index].componentName}`;
            } else {
              if (calculatedAmount > monthlyCompensation) {
                column[index].hasErrorAmount = true;
                column[index].errMsg = ERRORS_COMPONENTS.VARIABLE;
              } else {
                column[index].hasErrorAmount = false;
                column[index].errMsg = `Enter a valid ${column[index].componentName}`;
              }
            }
            updateDependentComponentValues(variableComponentColumnConfig, -1);
          } else {
            let calculatedAmount = getFixedAllowanceValue(monthlyCompensation, column);
            if (calculatedAmount > monthlyCompensation) {
              column[index].hasErrorAmount = true;
              column[index].errMsg = ERRORS_COMPONENTS.VARIABLE;
            } else {
              column[index].hasErrorAmount = false;
              column[index].errMsg = `Enter a valid ${column[index].componentName}`;
            }
          }
        } else {
          value = removeFirstDecimalFromInput(value);
          componentDefaultValues[object.id].amount = value;
          if(isComponentFormulaConfiguration()) {
            updateAmountForFormulaComponent(object.id)
          }
          let calculatedAmount = getFixedAllowanceValue(monthlyCompensation);
          if (Utility.isEmpty(value)) {
            columnConfig[index].hasErrorAmount = true;
            columnConfig[
              index
            ].errMsg = `Enter a valid ${object.componentName}`;
          } else {
            if (calculatedAmount > monthlyCompensation) {
              columnConfig[index].hasErrorAmount = true;
              columnConfig[index].errMsg = ERRORS_COMPONENTS.VARIABLE;
            } else {
              columnConfig[index].hasErrorAmount = false;
              columnConfig[
                index
              ].errMsg = `Enter a valid ${object.componentName}`;
            }
          }
          updateDependentComponentValues(variableComponentColumnConfig,-1);
          setFixedComponentColumnConfig(columnConfig);
        }
        break;
      case "Salary Advance":
        let columnConfigSalary = deepClone(salaryAdvanceFormFields);
        if (Utility.isEmpty(value) && object.required) {
          columnConfigSalary[index].hasError = true;
        } else {
          columnConfigSalary[index].hasError = false;
        }
        switch (object.id) {
          case COLUMN_CODES.AMOUNT:
            salaryAdvanceDefaultValues[object.id] = value;
            calculateNoOfInstallment();
            break;
          case COLUMN_CODES.DISBURSEMENT_DATE:
            if (!isSelectedDateofFutureMonth(object.id, value)) {
              columnConfigSalary[index].hasError = true;
              columnConfigSalary[
                index
              ].errMsg = `Disbursement date cannot be of past month`;
              salaryAdvanceDefaultValues[object.id] = "";
            } else {
              columnConfigSalary[index].hasError = false;
              columnConfigSalary[index].errMsg = `Enter a valid ${object.name}`;
              salaryAdvanceDefaultValues[object.id] = value;
            }
            if (
              !isRepaymentDateValid(
                value,
                salaryAdvanceDefaultValues[COLUMN_CODES.REPAYMENTSTART_DATE]
              )
            ) {
              columnConfigSalary[2].hasError = true;
              columnConfigSalary[2].errMsg = `Repayment date should be greater then Disbursement date`;
              salaryAdvanceDefaultValues[COLUMN_CODES.REPAYMENTSTART_DATE] = "";
            } else {
              columnConfigSalary[2].hasError = false;
              columnConfigSalary[2].errMsg = `Enter a valid ${object.name}`;
            }
            break;
          case COLUMN_CODES.REPAYMENTSTART_DATE:
            if (
              !isRepaymentDateValid(
                salaryAdvanceDefaultValues[COLUMN_CODES.DISBURSEMENT_DATE],
                value
              )
            ) {
              columnConfigSalary[index].hasError = true;
              columnConfigSalary[
                index
              ].errMsg = `Repayment date should be greater then Disbursement date`;
              salaryAdvanceDefaultValues[object.id] = "";
            } else {
              columnConfigSalary[index].hasError = false;
              salaryAdvanceDefaultValues[object.id] = value;
            }
            break;
          case COLUMN_CODES.INSTALLMENT_AMOUNT:
            salaryAdvanceDefaultValues[object.id] = value;
            calculateNoOfInstallment();
            break;
        }
        setSalaryAdvanceFormFields(columnConfigSalary);
        break;
      case "Variable":
        if (fieldName === "component") {
          let column = updateSelectedColumnForVariable(
            value,
            index,
            oldVariableComponentColumnConfig,
            object
          );
          let columnConfigVariable = oldVariableComponentColumnConfig;
          if(isComponentFormulaConfiguration()) {
            updateAmountForFormulaComponent(object.id,oldVariableComponentColumnConfig)
          }
          let amount = getOldFixedAllowanceValue(
            monthlyCompensation,
            oldFixedComponentColumnConfig,
            oldVariableComponentColumnConfig
          );
          if (amount > monthlyCompensation) {
            columnConfigVariable[index].hasErrorVariable = true;
            checkForFormulaValidation(true,oldVariableComponentColumnConfig)
          } else {
            columnConfigVariable[index].hasErrorVariable = false;
            checkForFormulaValidation(false,oldVariableComponentColumnConfig)
          }
        } else {
          if (Utility.isEmpty(value)) {
            value = 0;
          }
          let columnConfigVariable = oldVariableComponentColumnConfig;
          let isError = false;
          let errorMessage = "";
          if (
            (object.componentName === CONSTANTS.BASIC &&
            object.defaultComponent)
          ) {
            if (parseFloat(value) > CONSTANTS.BASIC_THRESHOLD) {
              isError = true;
              errorMessage = "Enter the percentage value between";
            }
          } else if(object.componentName === CONSTANTS.HRA) {
            if (parseFloat(value) > CONSTANTS.HRA_THRESHOLD) {
              isError = true;
              errorMessage = "Enter the percentage value between";
            }
          } else {
            if (object.isPercent) {
              if (parseFloat(value) > CONSTANTS.PERCENT_THRESHOLD) {
                isError = true;
              }
            }
          }
          if (!isError) {
            updateVariableValue(value, index, columnConfigVariable, object);
            if(isComponentFormulaConfiguration()) {
              updateAmountForFormulaComponent(object.id,oldVariableComponentColumnConfig)
            }
            let amount = getFixedAllowanceValue(monthlyCompensation);
            if (amount > monthlyCompensation) {
              columnConfigVariable[index].hasErrorVariable = true;
              columnConfigVariable[index].errMsgVariable =
                ERRORS_COMPONENTS.VARIABLE;
                checkForFormulaValidation(true,oldVariableComponentColumnConfig)
            } else {
              columnConfigVariable[index].hasErrorVariable = false;
              checkForFormulaValidation(false,oldVariableComponentColumnConfig)
            }
          }
        }
        break;
      case "benefit":
        let columnConfigBenefit = benefitColumnConfig;
        if (fieldName === "component") {
          let column = updateSelectedColumnBenefit(
            value,
            index,
            columnConfigBenefit,
            object
          );
        } else if (fieldName === "employeeCost") {
          value = removeFirstDecimalFromInput(value);
          componentDefaultValuesBenefit[object.id].employeeDeductionAmount =
            value;
          if (Utility.isEmpty(value)) {
            columnConfigBenefit[index].hasErrorEmployeeAmount = true;
            columnConfigBenefit[index].errMsg = `Enter a valid amount`;
          }
        } else if (fieldName === "employerCost") {
          value = removeFirstDecimalFromInput(value);
          componentDefaultValuesBenefit[object.id].employerDeductionAmount =
            value;
          if (Utility.isEmpty(value)) {
            columnConfigBenefit[index].hasErrorEmployerAmount = true;
            columnConfigBenefit[index].errMsg = `Enter a valid amount`;
          }
        }
    }

    props.setUserDataUpdated(true);
  };

  const isSelectedDateofFutureMonth = (columnCode, value) => {
    let currentMonthStartDate = moment().startOf("month").format("YYYY-MM-DD");
    let disbursementDate = moment(value).format("YYYY-MM-DD");
    let isFutureDateSelected = moment(disbursementDate).isSameOrAfter(
      currentMonthStartDate
    );
    return isFutureDateSelected;
  };

  const isRepaymentDateValid = (disbursementDate, repaymentStartDate) => {
    if (
      !Utility.isEmpty(repaymentStartDate) &&
      !Utility.isEmpty(disbursementDate)
    ) {
      let repaymentDate = moment(repaymentStartDate).format("YYYY-MM-DD");
      let disbursement = moment(disbursementDate).format("YYYY-MM-DD");
      let isRepaymentAheadOfDisbursement =
        moment(repaymentDate).isSameOrAfter(disbursement);
      return isRepaymentAheadOfDisbursement;
    }
    return true;
  };

  const calculateNoOfInstallment = () => {
    let installment = 0;
    const salaryAdvance = salaryAdvanceDefaultValues[COLUMN_CODES.AMOUNT]
      ? parseFloat(salaryAdvanceDefaultValues[COLUMN_CODES.AMOUNT])
      : 0;
    const installmentAmount = salaryAdvanceDefaultValues[
      COLUMN_CODES.INSTALLMENT_AMOUNT
    ]
      ? parseFloat(salaryAdvanceDefaultValues[COLUMN_CODES.INSTALLMENT_AMOUNT])
      : 0;
    if (
      !Utility.isEmpty(salaryAdvance) &&
      !Utility.isEmpty(installmentAmount)
    ) {
      installment = salaryAdvance / installmentAmount;
    }
    salaryAdvanceDefaultValues[COLUMN_CODES.INSTALLMENTS] = installment;
    return installment;
  };

  const updateVariableValue = (value, index, columnConfigs, object) => {
    let selection =
      componentMeta.components &&
      componentMeta.components.filter((x) => x.id === object.id);
    if (selection && selection.length > 0) {
      let selectedComponent = deepClone(selection[0]);
      let values = componentDefaultValuesVariable[selectedComponent.id];
      values["variableValue"] = value;
      let calculationValue = 0;
      if (
        selectedComponent.componentConfig.configureAmountBasis ==
        CONSTANTS.AMOUNT_PER_DAY
      ) {
        selectedComponent.componentConfig.amountPerDay = value;
        calculationValue = value;
      } else {
        selectedComponent.componentConfig.componentPercent = value;
        calculationValue = value;
      }
      const amount = getVariableComponentEstimatedAmount(selectedComponent);
      values["amount"] = amount;
      if (
        selectedComponent.componentConfig.configureAmountBasis ===
        CONSTANTS.AMOUNT_PER_DAY
      ) {
        values["componentPercent"] =
          selectedComponent.componentConfig.amountPerDay;
      } else {
        values["componentPercent"] =
          selectedComponent.componentConfig.componentPercent;
      }
      if (
        isIndiaCompliance() &&
        selectedComponent.defaultComponent &&
        selectedComponent.name == CONSTANTS.BASIC
      ) {
        let ind = variableComponent.findIndex(
          (component) =>
            component.name == CONSTANTS.HRA && component.defaultComponent
        );
        let component = variableComponent.filter(
          (component) =>
            component.name === CONSTANTS.HRA && component.defaultComponent
        );
        if (ind != -1 && component && component.length > 0) {
          updateHRABasedonBasic(component[0], index);
        }
      }
      updateDependentComponent(columnConfigs);
    }
  };

  const updateDependentComponent = (columnConfigs) => {
    let configs = deepClone(columnConfigs);
    configs.forEach((component) => {
      if (
        (component.defaultComponent && CONSTANTS.BASIC) ||
        (component.defaultComponent && CONSTANTS.HRA)
      ) {
      } else {
        let values = componentDefaultValuesVariable[component.id];
        if (
          component.componentConfig.configureAmountBasis ==
          CONSTANTS.AMOUNT_PER_DAY
        ) {
          component.componentConfig.amountPerDay = values["variableValue"];
        } else {
          component.componentConfig.componentPercent = values["variableValue"];
        }
        const amount = getVariableComponentEstimatedAmount(component);
        values["amount"] = amount;
      }
    });
  };

  const updateHRABasedonBasic = (variableComponent, index) => {
    let selectedComponent = deepClone(variableComponent);
    let values = (componentDefaultValuesVariable && componentDefaultValuesVariable[selectedComponent?.id]) ? componentDefaultValuesVariable[selectedComponent.id]:{};
    let calculationValue = 0;
    if (
      selectedComponent.componentConfig.configureAmountBasis ==
      CONSTANTS.AMOUNT_PER_DAY
    ) {
      selectedComponent.componentConfig.amountPerDay = values["variableValue"];
      calculationValue = values["variableValue"];
    } else {
      selectedComponent.componentConfig.componentPercent =
        values["variableValue"];
      calculationValue = values["variableValue"];
    }
    const amount = getVariableComponentEstimatedAmount(selectedComponent);
    values["amount"] = amount;
    if (
      selectedComponent.componentConfig.configureAmountBasis ==
      CONSTANTS.AMOUNT_PER_DAY
    ) {
      values["componentPercent"] =
        selectedComponent.componentConfig.amountPerDay;
    } else {
      values["componentPercent"] =
        selectedComponent.componentConfig.componentPercent;
    }
  };

  const updateSelectedColumn = (value, index, columnConfig, object) => {
    let selectedValue = !Utility.isEmpty(value)
      ? object.defaultOptions.find((x) => x.id === value.id)
      : "";
    if (selectedValue) {
      let isUpdate = checkIfUpdate(object, value);
      if (isUpdate) {
        fixedRemainingOptions.splice(0, fixedRemainingOptions.length);
        fixedRemainingDefaultOptions.splice(
          0,
          fixedRemainingDefaultOptions.length
        );
        let details =
          object.options && object.options ? deepClone(object.options) : [];
        details.forEach((element) => {
          fixedRemainingOptions.push(element);
        });
        let details1 = object.defaultOptions
          ? deepClone(object.defaultOptions)
          : [];
        details1.forEach((element) => {
          fixedRemainingDefaultOptions.push(element);
        });
      }
      let selectedColumn = columnConfig[index];
      selectedColumn["columnCode"] = selectedValue.id;
      selectedColumn["editable"] = true;
      selectedColumn["id"] = selectedValue.id;
      selectedColumn["index"] = index;
      selectedColumn["name"] = selectedValue.name;
      selectedColumn["componentName"] = selectedValue.name;
      selectedColumn["defaultComponent"] = selectedValue.defaultComponent;
      selectedColumn["isVariable"] = false;
      selectedColumn["componentType"] = selectedValue.type;
      selectedColumn["options"] = deepClone(object.options);
      selectedColumn["required"] = true;
      selectedColumn["systemField"] = true;
      selectedColumn["type"] = INPUT_TYPE.DROPDOWN;
      selectedColumn["uiVisible"] = true;
      selectedColumn["width"] = 40;
      selectedColumn["direction"] = "VERTICAL";
      selectedColumn["readonly"] =
        EmployeeListService.isReadOnlyField(selectedValue);
      selectedColumn["hasError"] = false;
      selectedColumn["hasErrorAmount"] = false;
      selectedColumn["errMsg"] = `Enter a valid ${selectedValue.name}`;
      selectedColumn["hasTooltip"] = !Utility.isEmpty(selectedValue.tooltip);
      selectedColumn["isEdit"] =
        EmployeeListService.isEditEnabled(selectedValue);
      selectedColumn["isDelete"] =
        EmployeeListService.isDeleteEnabled(selectedValue);
      selectedColumn["hasIcon"] =
        EmployeeListService.isTooltipIcon(selectedValue);
      selectedColumn["tooltipText"] = "";
      selectedColumn["defaultOptions"] = deepClone(object.defaultOptions);
      selectedColumn["frequency"] = selectedValue.frequency;
      selectedColumn["includeInCTC"] = selectedValue.includeInCTC;
      selectedColumn["includeInOTCalc"] = selectedValue.includeInOTCalc;
      selectedColumn["subType"] = selectedValue.subType;
      let defaults = {};
      let componentIndex = EmployeeListService.getComponentObjectIndex(
        selectedValue.id,
        fixedRemainingOptions,
        "id"
      );
      defaults["component"] =
        componentIndex != -1 ? fixedRemainingOptions[componentIndex] : [];
      defaults["amount"] = selectedValue.amount ? selectedValue.amount.toFixed(2) : 0;
      defaults["frequency"] =
        selectedValue.frequency && selectedValue.frequency.period
          ? EmployeeListService.getFrequency(selectedValue.frequency.period)
          : "";
      componentDefaultValues[selectedColumn["id"]] = defaults;
      fixedRemainingOptions.splice(componentIndex, 1);
      fixedRemainingDefaultOptions.splice(componentIndex, 1);
      updateDependentComponentValues(variableComponentColumnConfig,-1);
      updateColumnOptions(columnConfig);
    } else {
      let details = getDefaultColumnForFixed(columnConfig);
      let previousColumn = columnConfig[index];
      columnConfig.splice(index, 1, details);
      columnConfig[index].options = previousColumn.options;
      columnConfig[index].defaultOptions = previousColumn.defaultOptions;
      setFixedRemainingOptions(columnConfig[index].options);
      setFixedRemainingDefaultOptions(columnConfig[index].defaultOptions);
    }
    return columnConfig;
  };
  /*
  Calculate Component Amount Formula configuration
  */
  const getAmountFromFormula = (selectedValue) => {
    let finalAmount = 0;
    if(isComponentFormulaConfiguration() && (!Utility.isEmpty(selectedValue.formula) && !Utility.isEmpty(selectedValue.formulaConfig))) {
      let formulaConfig = deepClone(selectedValue.formulaConfig);
      let formulaString = deepClone(selectedValue.formula);
      formulaConfig.forEach(config=>{
        if(componentDefaultValues[config.componentId]) {
          config['percentageCalculation'] = getPercentage(componentDefaultValues[config.componentId].amount, config.percentage)
        } else if(componentDefaultValuesVariable[config.componentId]) {
          config['percentageCalculation'] = getPercentage(componentDefaultValuesVariable[config.componentId].amount, config.percentage)
        } else if(config.componentId == 'ctc') {
          let compensation = isIndiaCompliance() ? employeeDetails.ctc  : employeeDetails.compensation;
          config['percentageCalculation'] = getPercentage(compensation, config.percentage);
        } else {
          config['percentageCalculation'] = 0;
        }
        formulaString = formulaString?.replace(config.index,config['percentageCalculation']);
      })
      try{
        finalAmount = eval(formulaString)
        finalAmount = isFinite(finalAmount) ? finalAmount : 0;
        finalAmount.toFixed(2)
      } catch(e) {
        finalAmount = 0;
      }
    } else {
      finalAmount = selectedValue.amount ? selectedValue.amount.toFixed(2) : 0;
    }
    return !isNaN(parseFloat(finalAmount)) ? parseFloat(finalAmount.toFixed(2)) : 0;
  }
  /*
  Calculate Component Amount Formula configuration
  */
  const updateAmountForFormulaComponent = (componentId,isFromGroup) => {
    let formulaFields = [];
    let fixedComponent = isFromGroup ? deepClone(isFromGroup) :deepClone(fixedComponentColumnConfig);
    fixedComponent.forEach(column =>{
      let valueObj = componentDefaultValues[column.columnCode];
      if(valueObj && valueObj.component && valueObj.component.isFormula && !Utility.isEmpty(valueObj.component.formula)) {
        formulaFields.push(valueObj)
      }
    })
    formulaFields.forEach(formulaField=>{
      let component = formulaField.component.formulaConfig.find(config=>config.componentId == componentId);
      if(component && formulaField.component) {
        componentDefaultValues[formulaField.component.id].amount = getAmountFromFormula(formulaField.component)
      }
    })
    
  }

  /*
  Calculate All Component Amount Formula configuration
  */
  const updateFormulaAmountForAllComponent = (fixedConfigDetails) => {
    let formulaFields = [];
    let fixedComponent = (fixedConfigDetails) ? deepClone(fixedConfigDetails): deepClone(fixedComponentColumnConfig);
    fixedComponent.forEach(column =>{
      let valueObj = componentDefaultValues[column.columnCode];
      if(valueObj?.component && valueObj?.component.isFormula && !Utility.isEmpty(valueObj.component.formula)) {
        formulaFields.push(valueObj)
      }
    })
    formulaFields.forEach(formulaField=>{
      if(formulaField.component) {
        componentDefaultValues[formulaField.component.id].amount = getAmountFromFormula(formulaField.component)
      }
    })
    
  }
  const getPercentage =(amount,percentage)=>{
    let calculatedPercentage = 0;
    try{
      calculatedPercentage= amount ? ((parseFloat(amount))/100)*percentage :0
    } catch(e) {
      calculatedPercentage = 0
    }
    return calculatedPercentage
  }
  const updateSelectedColumnForVariable = (
    value,
    index,
    columnConfig,
    object
  ) => {
    let selectedValue = !Utility.isEmpty(value)
      ? object.defaultOptions.find((x) => x.id === value.id)
      : "";
    if (selectedValue) {
      let isUpdate = checkIfUpdateForVariable(object, value);
      if (isUpdate) {
        variableRemainingOptions.splice(0, variableRemainingOptions.length);
        variableRemainingDefaultOptions.splice(
          0,
          variableRemainingDefaultOptions.length
        );
        let details =
          object.options && object.options ? deepClone(object.options) : [];
        details.forEach((element) => {
          variableRemainingOptions.push(element);
        });
        let details1 = object.defaultOptions
          ? deepClone(object.defaultOptions)
          : [];
        details1.forEach((element) => {
          variableRemainingDefaultOptions.push(element);
        });
      }
      let selectedColumn = columnConfig[index];
      selectedColumn["columnCode"] = selectedValue.id;
      selectedColumn["editable"] = true;
      selectedColumn["id"] = selectedValue.id;
      selectedColumn["index"] = index;
      selectedColumn["name"] = selectedValue.name;
      selectedColumn["componentName"] = selectedValue.name;
      selectedColumn["defaultComponent"] = selectedValue.defaultComponent;
      selectedColumn["isVariable"] = true;
      selectedColumn["variableName"] =
        EmployeeListService.getVariableFieldName(selectedValue);
      selectedColumn["isPercent"] =
        EmployeeListService.isPercentageConfigured(selectedValue);
      selectedColumn["componentType"] = selectedValue.type;
      selectedColumn["options"] = deepClone(object.options);
      selectedColumn["required"] = true;
      selectedColumn["systemField"] = true;
      selectedColumn["type"] = INPUT_TYPE.DROPDOWN;
      selectedColumn["uiVisible"] = true;
      selectedColumn["width"] = 40;
      selectedColumn["direction"] = "VERTICAL";
      selectedColumn["readonly"] =
        EmployeeListService.isReadOnlyField(selectedValue);
      selectedColumn["hasError"] = false;
      selectedColumn["hasErrorVariable"] = false;
      selectedColumn["errMsg"] = `Enter a valid ${selectedValue.name}`;
      selectedColumn["errMsgVariable"] = ERRORS_COMPONENTS.VARIABLE;
      selectedColumn["hasTooltip"] = !Utility.isEmpty(selectedValue.tooltip);
      selectedColumn["isEdit"] =
        EmployeeListService.isEditEnabled(selectedValue);
      selectedColumn["isDelete"] =
        EmployeeListService.isDeleteEnabled(selectedValue);
      selectedColumn["hasIcon"] =
        EmployeeListService.isTooltipIcon(selectedValue);
      selectedColumn["hasIconFrequency"] =
        EmployeeListService.isTooltipIcon(selectedValue);
      selectedColumn["tooltipText"] = "";
      selectedColumn["defaultOptions"] = deepClone(object.defaultOptions);
      selectedColumn["frequency"] = selectedValue.frequency;
      selectedColumn["componentConfig"] = selectedValue.componentConfig;
      selectedColumn["includeInCTC"] = selectedValue.includeInCTC;
      selectedColumn["includeInOTCalc"] = selectedValue.includeInOTCalc;
      selectedColumn["subType"] = selectedValue.subType;
      selectedColumn["hasInfo"] =
        EmployeeListService.hasInfoIcon(selectedValue);
        selectedColumn["hasInfoText"] = `Entered percentage value has been restricted to ${selectedColumn['subType'] === "basic_salary" ?  CONSTANTS.BASIC_THRESHOLD : CONSTANTS.HRA_THRESHOLD}%`;
      let defaults = {};
      let componentIndex = EmployeeListService.getComponentObjectIndex(
        selectedValue.id,
        variableRemainingOptions,
        "id"
      );
      defaults["component"] =
        componentIndex != -1 ? variableRemainingOptions[componentIndex] : [];
      defaults["amount"] = selectedValue.amount
        ? selectedValue.amount.toFixed(2)
        : 0;
      defaults["frequency"] =
        selectedValue.frequency && selectedValue.frequency.period
          ? EmployeeListService.getFrequency(selectedValue.frequency.period)
          : "";
      defaults["variableValue"] =
        selectedValue && selectedValue.componentConfig
          ? EmployeeListService.getVariableValue(
              selectedColumn["isPercent"],
              selectedValue
            )
          : 0;
      defaults["amount"] = getVariableComponentEstimatedAmount(selectedValue);
      componentDefaultValuesVariable[selectedColumn["id"]] = defaults;// set value against id 
      variableRemainingOptions.splice(componentIndex, 1);
      variableRemainingDefaultOptions.splice(componentIndex, 1);
      updateDependentComponentValues(columnConfig,index);
      updateColumnOptionsForVariable(columnConfig);
    } else {
      let details = getDefaultColumnForVariable(columnConfig);
      let previousColumn = columnConfig[index];
      columnConfig.splice(index, 1, details);
      columnConfig[index].options = previousColumn.options;
      columnConfig[index].defaultOptions = previousColumn.defaultOptions;
      setVariableRemainingOptions(columnConfig[index].options);
      setVariableRemainingDefaultOptions(columnConfig[index].defaultOptions);
    }
    return columnConfig;
  };

  const updateDependentComponentValues = (columnConfig,index) => {
    columnConfig.forEach((column,ind)=>{
      if(index != ind && columnConfig[ind]?.componentConfig?.configureAmountBasis == "percentageOfSpecificComponent") {
      componentDefaultValuesVariable[column["id"]]['amount'] = getVariableComponentEstimatedAmount(column);
      }
    })
  }

  const getVariableComponentEstimatedAmount = (variableComponent) => {
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    const amount = getVariableComponentEstimationAmount(
      variableComponent,
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      componentMeta.components,
      componentDefaultValuesVariable,
      componentDefaultValues,
      employeeDetails
    );
    return amount ? amount : 0;
  };

  const checkIfUpdate = (obj, value) => {
    let isUpdate = false;
    if (
      componentDefaultValues[obj.id] &&
      !Utility.isEmpty(componentDefaultValues[obj.id].component)
    ) {
      isUpdate = true;
    }

    return isUpdate;
  };

  const checkIfUpdateForVariable = (obj, value) => {
    let isUpdate = false;
    if (
      componentDefaultValuesVariable[obj.id] &&
      !Utility.isEmpty(componentDefaultValuesVariable[obj.id].component)
    ) {
      isUpdate = true;
    }

    return isUpdate;
  };

  const checkIfUpdateForBenefit = (obj, value) => {
    let isUpdate = false;
    if (
      componentDefaultValuesBenefit[obj.id] &&
      !Utility.isEmpty(componentDefaultValuesBenefit[obj.id].component)
    ) {
      isUpdate = true;
    }

    return isUpdate;
  };

  const updateColumnOptions = (columnConfig, isInitailCall) => {
    columnConfig.forEach((item) => {
      if (componentDefaultValues[item["id"]]) {
        let selectedComponent = componentDefaultValues[item["id"]]["component"];
        let unselectedOptions = filterRemainingOptionByEmployeeApplicability(fixedRemainingOptions);
        let unselectedDefaultOptions = deepClone(fixedRemainingDefaultOptions);
        let element = item["options"].find((x) => x.id == selectedComponent.id);
        let element01 = item["defaultOptions"].find(
          (x) => x.id == selectedComponent.id
        );
        unselectedOptions.push(element);
        item["options"] = unselectedOptions;
        unselectedDefaultOptions.push(element01);
        item["defaultOptions"] = unselectedDefaultOptions;
        let componentIndex = EmployeeListService.getComponentObjectIndex(
          item.id,
          item["options"],
          "id"
        );
        componentDefaultValues[item["id"]]["component"] =
          componentIndex != -1 ? item["options"][componentIndex] : [];
      }
    });
  };

  const updateColumnOptionsForVariable = (columnConfig,isInitailCall) => {
    columnConfig.forEach((item) => {
      if (componentDefaultValuesVariable[item["id"]]) {
        let selectedComponent =
          componentDefaultValuesVariable[item["id"]]["component"];
        let unselectedOptions = filterRemainingOptionByEmployeeApplicability(variableRemainingOptions);
        let unselectedDefaultOptions = deepClone(
          variableRemainingDefaultOptions
        );
        let element = item["options"].find((x) => x.id == selectedComponent.id);
        let element01 = item["defaultOptions"].find(
          (x) => x.id == selectedComponent.id
        );
        unselectedOptions.push(element);
        item["options"] = unselectedOptions;
        unselectedDefaultOptions.push(element01);
        item["defaultOptions"] = unselectedDefaultOptions;
        let componentIndex = EmployeeListService.getComponentObjectIndex(
          item.id,
          item["options"],
          "id"
        );
        componentDefaultValuesVariable[item["id"]]["component"] =
          componentIndex != -1 ? item["options"][componentIndex] : [];
      }
    });
  };

  const addColumnConfigForFixedComponent = () => {
    let columnConfig = deepClone(fixedComponentColumnConfig);
    let isValid = componentSelected(columnConfig);
    if (isValid) {
      let details = getDefaultColumnForFixed(columnConfig);
      columnConfig.push(details);
    } else {
    }
    setFixedComponentColumnConfig(columnConfig);
  };

  const addColumnConfigForVariableComponent = () => {
    let columnConfig = deepClone(variableComponentColumnConfig);
    let isValid = variableComponentSelected(columnConfig);
    if (isValid) {
      let details = getDefaultColumnForVariable(columnConfig);
      columnConfig.push(details);
    } else {
    }
    setVariableComponentColumnConfig(columnConfig);
  };

  var oldSelectComponentGroup = null;
  const getDefaultColumnForFixed = (columnConfig) => {
    let fieldGroup = {};
    let index = columnConfig.length;
    fieldGroup["columnCode"] = "";
    fieldGroup["editable"] = true;
    fieldGroup["id"] = "";
    fieldGroup["index"] = index;
    fieldGroup["name"] = "Component";
    fieldGroup["componentName"] = "";
    fieldGroup["isVariable"] = false;
    fieldGroup["defaultComponent"] = false;
    fieldGroup["componentType"] = "";
    fieldGroup["options"] = filterRemainingOptionByEmployeeApplicability(fixedRemainingOptions);
    fieldGroup["required"] = true;
    fieldGroup["systemField"] = true;
    fieldGroup["type"] = INPUT_TYPE.DROPDOWN;
    fieldGroup["uiVisible"] = true;
    fieldGroup["direction"] = "VERTICAL";
    fieldGroup["readonly"] = false;
    fieldGroup["hasError"] = true;
    fieldGroup["hasErrorAmount"] = false;
    fieldGroup["errMsg"] = `Enter a valid component name`;
    fieldGroup["hasTooltip"] = false;
    fieldGroup["isEdit"] = false;
    fieldGroup["isDelete"] = true;
    fieldGroup["hasIcon"] = false;
    fieldGroup["tooltipText"] = "";
    fieldGroup["defaultOptions"] = deepClone(fixedRemainingDefaultOptions);
    fieldGroup["frequency"] = {};
    fieldGroup["includeInCTC"] = false;
    fieldGroup["includeInOTCalc"] = false;
    fieldGroup["subType"] = "";
    fieldGroup["hasInfo"] = false;
    fieldGroup["hasInfoText"] = ``;
    return fieldGroup;
  };
  const filterRemainingOptionByEmployeeApplicability = (components) => {
    let userId = employeeDetails.userId;
    let newOptions = [];
    components.forEach(cmp => {
      if (cmp.isForAllEmployee) {
        newOptions.push(cmp);
      } else {
        if (cmp.employees.includes(userId)) {
          newOptions.push(cmp);
        }
     }
    })
    return deepClone(newOptions);
  }
  const getDefaultColumnForVariable = (columnConfig) => {
    let fieldGroup = {};
    let index = columnConfig.length;
    fieldGroup["columnCode"] = "";
    fieldGroup["editable"] = true;
    fieldGroup["id"] = "";
    fieldGroup["index"] = index;
    fieldGroup["name"] = "Component";
    fieldGroup["componentName"] = "";
    fieldGroup["isVariable"] = true;
    fieldGroup["defaultComponent"] = false;
    fieldGroup["variableName"] = "";
    fieldGroup["componentType"] = "";
    fieldGroup["options"] = filterRemainingOptionByEmployeeApplicability(variableRemainingOptions);
    fieldGroup["isPercent"] = false;
    fieldGroup["componentType"] = "";
    fieldGroup["required"] = true;
    fieldGroup["systemField"] = true;
    fieldGroup["type"] = INPUT_TYPE.DROPDOWN;
    fieldGroup["uiVisible"] = true;
    fieldGroup["direction"] = "VERTICAL";
    fieldGroup["readonly"] = false;
    fieldGroup["hasError"] = true;
    fieldGroup["hasErrorVariable"] = false;
    fieldGroup["errMsg"] = `Enter a valid component name`;
    fieldGroup["errMsgVariable"] = ERRORS_COMPONENTS.VARIABLE;
    fieldGroup["hasTooltip"] = false;
    fieldGroup["isEdit"] = false;
    fieldGroup["isDelete"] = true;
    fieldGroup["hasIcon"] = false;
    fieldGroup["hasIconFrequency"] = false;
    fieldGroup["tooltipText"] = "";
    fieldGroup["defaultOptions"] = deepClone(variableRemainingDefaultOptions);
    fieldGroup["frequency"] = {};
    fieldGroup["componentConfig"] = {};
    fieldGroup["includeInCTC"] = false;
    fieldGroup["includeInOTCalc"] = false;    
    fieldGroup["subType"] = "";
    return fieldGroup;
  };

  const componentSelected = (columns) => {
    let isValid = true;
    for (let i = 0; i < columns.length; i++) {
      let details = columns[i];
      if (
        componentDefaultValues[details.id] &&
        !Utility.isEmpty(componentDefaultValues[details.id].component)
      ) {
        isValid = true;
      } else {
        isValid = false;
        columns["hasError"] = true;
        return isValid;
      }
    }
    return isValid;
  };

  const variableComponentSelected = (columns) => {
    let isValid = true;
    for (let i = 0; i < columns.length; i++) {
      let details = columns[i];
      if (
        componentDefaultValuesVariable[details.id] &&
        !Utility.isEmpty(componentDefaultValuesVariable[details.id].component)
      ) {
        isValid = true;
      } else {
        isValid = false;
        columns["hasError"] = true;
        return isValid;
      }
    }
    return isValid;
  };
  const benefitComponentSelected = (columns) => {
    let isValid = true;
    for (let i = 0; i < columns.length; i++) {
      let details = columns[i];
      if (
        componentDefaultValuesBenefit[details.id] &&
        !Utility.isEmpty(componentDefaultValuesBenefit[details.id].component)
      ) {
        isValid = true;
      } else {
        isValid = false;
        columns["hasError"] = true;
        return isValid;
      }
    }
    return isValid;
  };

  const onDeleteFixedComponent = (index, object) => {
    fixedComponentColumnConfig.splice(index, 1);
    let columnConfig = deepClone(fixedComponentColumnConfig);
    if (
      componentDefaultValues[object.id] &&
      componentDefaultValues[object.id].component
    ) {
      let selectedOption = componentDefaultValues[object.id].component;
      let selectedValue = object.options.find(
        (x) => x.id === selectedOption["id"]
      );
      let selectedDefaultValue = object.defaultOptions.find(
        (x) => x.id === selectedOption["id"]
      );
      let remainingValue = deepClone(fixedRemainingOptions);
      let remainingDefaultValue = deepClone(fixedRemainingDefaultOptions);
      fixedRemainingOptions.splice(0, fixedRemainingOptions.length);
      fixedRemainingDefaultOptions.splice(
        0,
        fixedRemainingDefaultOptions.length
      );
      fixedRemainingOptions.push(selectedValue);
      remainingValue.forEach((element) => {
        fixedRemainingOptions.push(element);
      });
      fixedRemainingDefaultOptions.push(selectedDefaultValue);
      remainingDefaultValue.forEach((element) => {
        fixedRemainingDefaultOptions.push(element);
      });
    }
    delete componentDefaultValues[object.id];
    updateColumnOptions(columnConfig);
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
    updateFormulaAmountForAllComponent()
    let amount = getFixedAllowanceValue(monthlyCompensation);
    setFixedComponentColumnConfig(columnConfig);
    props.setUserDataUpdated(true);
  };

  const onDeleteOldGroupComponent = (index, oldColumnConfig, object) => {
    oldColumnConfig.splice(index, 1);
    if (
      componentDefaultValues[object.id] &&
      componentDefaultValues[object.id].component
    ) {
      let selectedOption = componentDefaultValues[object.id].component;
      let selectedValue = object.options.find(
        (x) => x.id === selectedOption.id
      );
      let selectedDefaultValue = object.defaultOptions.find(
        (x) => x.id === selectedOption.id
      );
      let remainingValue = deepClone(fixedRemainingOptions);
      let remainingDefaultValue = deepClone(fixedRemainingDefaultOptions);
      fixedRemainingOptions.splice(0, fixedRemainingOptions.length);
      fixedRemainingDefaultOptions.splice(
        0,
        fixedRemainingDefaultOptions.length
      );
      fixedRemainingOptions.push(selectedValue);
      remainingValue.forEach((element) => {
        fixedRemainingOptions.push(element);
      });
      fixedRemainingDefaultOptions.push(selectedDefaultValue);
      remainingDefaultValue.forEach((element) => {
        fixedRemainingDefaultOptions.push(element);
      });
    }
    delete componentDefaultValues[object.id];
    updateColumnOptions(oldColumnConfig);
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
  };
  const onDeleteGroupVariableComponent = (index, oldColumnConfig, object) => {
    oldColumnConfig.splice(index, 1);
    let columnConfig = oldColumnConfig;
    if (
      componentDefaultValuesVariable[object.id] &&
      componentDefaultValuesVariable[object.id].component
    ) {
      let selectedOption = componentDefaultValuesVariable[object.id].component;
      let selectedValue = object.options.find(
        (x) => x.id === selectedOption["id"]
      );
      let selectedDefaultValue = object.defaultOptions.find(
        (x) => x.id === selectedOption["id"]
      );
      let remainingValue = deepClone(variableRemainingOptions);
      let remainingDefaultValue = deepClone(variableRemainingDefaultOptions);
      variableRemainingOptions.splice(0, variableRemainingOptions.length);
      variableRemainingDefaultOptions.splice(
        0,
        variableRemainingDefaultOptions.length
      );
      variableRemainingOptions.push(selectedValue);
      remainingValue.forEach((element) => {
        variableRemainingOptions.push(element);
      });
      variableRemainingDefaultOptions.push(selectedDefaultValue);
      remainingDefaultValue.forEach((element) => {
        variableRemainingDefaultOptions.push(element);
      });
    }
    delete componentDefaultValuesVariable[object.id];
    updateColumnOptionsForVariable(columnConfig);
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
  };

  const onDeleteVariableComponent = (index, object) => {
    variableComponentColumnConfig.splice(index, 1);
    let columnConfig = deepClone(variableComponentColumnConfig);
    if (
      componentDefaultValuesVariable[object.id] &&
      componentDefaultValuesVariable[object.id].component
    ) {
      let selectedOption = componentDefaultValuesVariable[object.id].component;
      let selectedValue = object.options.find(
        (x) => x.id === selectedOption["id"]
      );
      let selectedDefaultValue = object.defaultOptions.find(
        (x) => x.id === selectedOption["id"]
      );
      let remainingValue = deepClone(variableRemainingOptions);
      let remainingDefaultValue = deepClone(variableRemainingDefaultOptions);
      variableRemainingOptions.splice(0, variableRemainingOptions.length);
      variableRemainingDefaultOptions.splice(
        0,
        variableRemainingDefaultOptions.length
      );
      variableRemainingOptions.push(selectedValue);
      remainingValue.forEach((element) => {
        variableRemainingOptions.push(element);
      });
      variableRemainingDefaultOptions.push(selectedDefaultValue);
      remainingDefaultValue.forEach((element) => {
        variableRemainingDefaultOptions.push(element);
      });
    }
    delete componentDefaultValuesVariable[object.id];
    updateColumnOptionsForVariable(columnConfig);
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
    updateFormulaAmountForAllComponent()
    let amount = getFixedAllowanceValue(monthlyCompensation);
    setVariableComponentColumnConfig(columnConfig);
    props.setUserDataUpdated(true);
  };

  const onEditFixedComponent = (index, object) => {
    console.log("edit");
  };

  const enableSalaryAdvance = () => {
    setSalaryAdvance(!isSalaryAdvance);
  };

  const getFixedAllowanceValue = (compensation,newFixedComponent) => {
    let amount = 0;
    let fixedComponents = deepClone(newFixedComponent ? newFixedComponent : fixedComponentColumnConfig);
    let variableComponents = deepClone(variableComponentColumnConfig);
    let fixedEarning = fixedComponents.filter(
      (x) => x.componentType === CONSTANTS.EARNING
    );
    let variableEarning = variableComponents.filter(
      (x) => x.componentType === CONSTANTS.EARNING
    );
    let componentId = "";
    fixedEarning.forEach((element) => {
      let includeInCTC =
        (element.defaultComponent && element.includeInCTC) ||
        (element.componentType == COMPONENT_TYPE.EARNING &&
          element.includeInCTC)
          ? true
          : false;
      if (element.componentName != CONSTANTS.FIXED_ALLOWANCE && includeInCTC) {
        amount += parseFloat(componentDefaultValues[element.id].amount || 0);
      } else if (
        element.defaultComponent &&
        element.componentName === CONSTANTS.FIXED_ALLOWANCE
      ) {
        componentId = element.id;
      }
    });
    variableEarning.forEach((element) => {
      let includeInCTC =
        (element.defaultComponent && element.includeInCTC) ||
        (element.componentType == COMPONENT_TYPE.EARNING &&
          element.includeInCTC)
          ? true
          : false;
      if (includeInCTC) {
        amount += parseFloat(componentDefaultValuesVariable[element.id].amount || 0);
      }
    });

    if (componentDefaultValues[componentId]) {
        const allowanceAmount = parseFloat(compensation) - parseFloat(amount);
        componentDefaultValues[componentId].amount = allowanceAmount > 0 ? allowanceAmount.toFixed(2) : 0;
    }

    return getTenantDeciamlFormattedAmount(parseFloat(amount));
  };

  const getOldFixedAllowanceValue = (
    compensation,
    oldFixedComponentColumnConfig,
    oldVariableComponentColumnConfig
  ) => {
    let amount = 0;
    let fixedComponents = oldFixedComponentColumnConfig;
    let variableComponents = oldVariableComponentColumnConfig;
    let fixedEarning = fixedComponents.filter(
      (x) => x.componentType === CONSTANTS.EARNING
    );
    let variableEarning = variableComponents.filter(
      (x) => x.componentType === CONSTANTS.EARNING
    );
    let componentId = "";
    fixedEarning.forEach((element) => {
      let includeInCTC =
        (element.defaultComponent && element.includeInCTC) ||
        (element.componentType == COMPONENT_TYPE.EARNING &&
          element.includeInCTC)
          ? true
          : false;
      if (element.componentName != CONSTANTS.FIXED_ALLOWANCE && includeInCTC) {
        amount += parseFloat(
          componentDefaultValues[element.id]
            ? componentDefaultValues[element.id].amount
            : 0
        );
      } else if (
        element.defaultComponent &&
        element.componentName === CONSTANTS.FIXED_ALLOWANCE
      ) {
        componentId = element.id;
      }
    });
    variableEarning.forEach((element) => {
      let includeInCTC =
        (element.defaultComponent && element.includeInCTC) ||
        (element.componentType == COMPONENT_TYPE.EARNING &&
          element.includeInCTC)
          ? true
          : false;
      if (includeInCTC) {
        amount += parseFloat(componentDefaultValuesVariable[element.id].amount);
      }
    });
    if (compensation - amount > 0) {
      if (componentDefaultValues[componentId]) {
        let allowanceAmount = parseFloat(compensation) - parseFloat(amount);
        componentDefaultValues[componentId].amount = allowanceAmount.toFixed(2);
      }
    }

    return parseFloat(amount);
  };

  const addColumnConfigForBenefitComponent = () => {
    let columnConfig = deepClone(benefitComponentColumnConfig);
    let isValid = benefitComponentSelected(columnConfig);
    if (isValid) {
      let details = getDefaultColumnForBenefit(columnConfig);
      columnConfig.push(details);
    } else {
    }
    setBenefitComponentColumnConfig(columnConfig);
  };

  const getDefaultColumnForBenefit = (columnConfig) => {
    let fieldGroup = {};
    let index = columnConfig.length;
    fieldGroup["columnCode"] = "";
    fieldGroup["editable"] = true;
    fieldGroup["id"] = "";
    fieldGroup["index"] = index;
    fieldGroup["name"] = "Component";
    fieldGroup["componentName"] = "";
    fieldGroup["employeeDeductionType"] = "";
    fieldGroup["employerDeductionType"] = "";
    fieldGroup["componentType"] = "BENEFIT";
    fieldGroup["options"] = deepClone(benefitRemainingOptions);
    fieldGroup["required"] = true;
    fieldGroup["systemField"] = true;
    fieldGroup["type"] = INPUT_TYPE.DROPDOWN;
    fieldGroup["uiVisible"] = true;
    fieldGroup["direction"] = "VERTICAL";
    fieldGroup["readonly"] = false;
    fieldGroup["hasError"] = true;
    fieldGroup["hasErrorEmployeeAmount"] = false;
    fieldGroup["hasErrorEmployerAmount"] = false;
    fieldGroup["errMsg"] = `Enter a valid component name`;
    fieldGroup["hasTooltip"] = false;
    fieldGroup["isEdit"] = false;
    fieldGroup["isDelete"] = true;
    fieldGroup["hasIcon"] = false;
    fieldGroup["tooltipText"] = "";
    fieldGroup["defaultOptions"] = deepClone(benefitRemainingDefaultOptions);
    fieldGroup["hasInfo"] = false;
    fieldGroup["hasInfoText"] = ``;
    fieldGroup["isForAllEmployees"] = true;
    fieldGroup["users"] = [];
    return fieldGroup;
  };

  const onDeleteBenefitComponent = (index, object) => {
    benefitComponentColumnConfig.splice(index, 1);
    let columnConfig = deepClone(benefitComponentColumnConfig);
    if (
      componentDefaultValuesBenefit[object.id] &&
      componentDefaultValuesBenefit[object.id].component
    ) {
      let selectedOption = componentDefaultValuesBenefit[object.id].component;
      let selectedValue = object.options.find(
        (x) => x.benefitId === selectedOption["benefitId"]
      );
      let selectedDefaultValue = object.defaultOptions.find(
        (x) => x.benefitId === selectedOption["benefitId"]
      );
      let remainingValue = deepClone(benefitRemainingOptions);
      let remainingDefaultValue = deepClone(benefitRemainingDefaultOptions);
      benefitRemainingOptions.splice(0, benefitRemainingOptions.length);
      benefitRemainingDefaultOptions.splice(
        0,
        benefitRemainingDefaultOptions.length
      );
      benefitRemainingOptions.push(selectedValue);
      remainingValue.forEach((element) => {
        benefitRemainingOptions.push(element);
      });
      benefitRemainingDefaultOptions.push(selectedDefaultValue);
      remainingDefaultValue.forEach((element) => {
        benefitRemainingDefaultOptions.push(element);
      });
    }
    delete componentDefaultValuesBenefit[object.id];
    updateColumnOptionsForBenefit(columnConfig);
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
    setBenefitComponentColumnConfig(columnConfig);
    props.setUserDataUpdated(true);
  };

  const onDeleteOldBenefitComponent = (index, oldColumnConfig, object) => {
    oldColumnConfig.splice(index, 1);
    let columnConfig = oldColumnConfig;
    if (
      componentDefaultValuesBenefit[object.id] &&
      componentDefaultValuesBenefit[object.id].component
    ) {
      let selectedOption = componentDefaultValuesBenefit[object.id].component;
      let selectedValue = object.options.find(
        (x) => x.benefitId === selectedOption["benefitId"]
      );
      let selectedDefaultValue = object.defaultOptions.find(
        (x) => x.benefitId === selectedOption["benefitId"]
      );
      let remainingValue = deepClone(benefitRemainingOptions);
      let remainingDefaultValue = deepClone(benefitRemainingDefaultOptions);
      benefitRemainingOptions.splice(0, benefitRemainingOptions.length);
      benefitRemainingDefaultOptions.splice(
        0,
        benefitRemainingDefaultOptions.length
      );
      benefitRemainingOptions.push(selectedValue);
      remainingValue.forEach((element) => {
        benefitRemainingOptions.push(element);
      });
      benefitRemainingDefaultOptions.push(selectedDefaultValue);
      remainingDefaultValue.forEach((element) => {
        benefitRemainingDefaultOptions.push(element);
      });
    }
    delete componentDefaultValuesBenefit[object.id];
    updateColumnOptionsForBenefit(columnConfig);
    let compensation = isIndiaCompliance()
      ? employeeDetails.ctc
      : employeeDetails.compensation;
    let monthlyCompensation = getCompensationInPerMonth(
      employeeDetails.compensationPeriod,
      compensation,
      tenantData.tenant.workWeekDetails,
      employeeDetails
    );
  };

  const updateColumnOptionsForBenefit = (columnConfig) => {
    columnConfig.forEach((item) => {
      if (componentDefaultValuesBenefit[item["id"]]) {
        let selectedComponent =
          componentDefaultValuesBenefit[item["id"]]["component"];
        let unselectedOptions = deepClone(benefitRemainingOptions);
        let unselectedDefaultOptions = deepClone(
          benefitRemainingDefaultOptions
        );
        let element = item["options"].find(
          (x) => x.benefitId == selectedComponent.benefitId
        );
        let element01 = item["defaultOptions"].find(
          (x) => x.benefitId == selectedComponent.benefitId
        );
        unselectedOptions.push(element);
        item["options"] = unselectedOptions;
        unselectedDefaultOptions.push(element01);
        item["defaultOptions"] = unselectedDefaultOptions;
        let componentIndex = EmployeeListService.getComponentObjectIndex(
          item.id,
          item["options"],
          "benefitId"
        );
        componentDefaultValuesBenefit[item["id"]]["component"] =
          componentIndex != -1 ? item["options"][componentIndex] : [];
      }
    });
  };

  const updateSelectedColumnBenefit = (value, index, columnConfig, object) => {
    const selectedValue = !Utility.isEmpty(value) ? object.defaultOptions.find((x) => x.benefitId === value.benefitId) : "";
    if (selectedValue) {
      let isUpdate = checkIfUpdateForBenefit(object, value);
      if (isUpdate) {
        benefitRemainingOptions.splice(0, fixedRemainingOptions.length);
        benefitRemainingDefaultOptions.splice(
          0,
          benefitRemainingDefaultOptions.length
        );
        let details =
          object.options && object.options ? deepClone(object.options) : [];
        details.forEach((element) => {
          benefitRemainingOptions.push(element);
        });
        let details1 = object.defaultOptions
          ? deepClone(object.defaultOptions)
          : [];
        details1.forEach((element) => {
          benefitRemainingDefaultOptions.push(element);
        });
      }
      let selectedColumn = columnConfig[index];
      selectedColumn["columnCode"] = selectedValue.benefitId;
      selectedColumn["editable"] = true;
      selectedColumn["id"] = selectedValue.benefitId;
      selectedColumn["index"] = index;
      selectedColumn["name"] = selectedValue.name;
      selectedColumn["componentName"] = selectedValue.name;
      selectedColumn["employeeDeductionType"] =
        selectedValue.employeeDeductionType;
      selectedColumn["employerDeductionType"] =
        selectedValue.employerDeductionType;
      selectedColumn["componentType"] = "BENEFIT";
      selectedColumn["options"] = deepClone(object.options);
      selectedColumn["required"] = true;
      selectedColumn["systemField"] = true;
      selectedColumn["type"] = INPUT_TYPE.DROPDOWN;
      selectedColumn["uiVisible"] = true;
      selectedColumn["width"] = 40;
      selectedColumn["direction"] = "VERTICAL";
      selectedColumn["hasError"] = false;
      selectedColumn["hasErrorEmployeeAmount"] = false;
      selectedColumn["hasErrorEmployerAmount"] = false;
      selectedColumn["errMsg"] = `Enter a valid ${selectedValue.name}`;
      selectedColumn["hasTooltip"] = !Utility.isEmpty(selectedValue.tooltip);
      selectedColumn["isEdit"] =
        EmployeeListService.isEditEnabled(selectedValue);
      selectedColumn["isDelete"] =
        EmployeeListService.isDeleteEnabled(selectedValue);
      selectedColumn["hasIcon"] =
        EmployeeListService.isTooltipIcon(selectedValue);
      selectedColumn["tooltipText"] = "";
      selectedColumn["defaultOptions"] = deepClone(object.defaultOptions);
      selectedColumn["isForAllEmployees"] = selectedValue.isForAllEmployees;
      selectedColumn["users"] = selectedValue.users;
      let defaults = {};
      let componentIndex = EmployeeListService.getComponentObjectIndex(
        selectedValue.benefitId,
        benefitRemainingOptions,
        "benefitId"
      );
      defaults["component"] =
        componentIndex != -1 ? benefitRemainingOptions[componentIndex] : [];
      defaults["employeeDeductionAmount"] =
        selectedValue.employeeDeductionAmount
          ? selectedValue.employeeDeductionAmount.toFixed(2)
          : 0;
      defaults["employerDeductionAmount"] =
        selectedValue.employerDeductionAmount
          ? selectedValue.employerDeductionAmount.toFixed(2)
          : 0;
      defaults["employeeDeductionType"] = selectedValue.employeeDeductionType
        ? selectedValue.employeeDeductionType
        : "";
      defaults["employerDeductionType"] = selectedValue.employeeDeductionType
        ? selectedValue.employeeDeductionType
        : "";
      componentDefaultValuesBenefit[selectedColumn["id"]] = defaults;
      benefitRemainingOptions.splice(componentIndex, 1);
      benefitRemainingDefaultOptions.splice(componentIndex, 1);
      updateColumnOptionsForBenefit(columnConfig);
    } else {
      let details = getDefaultColumnForBenefit(columnConfig);
      let previousColumn = columnConfig[index];
      columnConfig.splice(index, 1, details);
      columnConfig[index].options = previousColumn.options;
      columnConfig[index].defaultOptions = previousColumn.defaultOptions;
      setBenefitRemainingOptions(columnConfig[index].options);
      setBenefitRemainingDefaultOptions(columnConfig[index].defaultOptions);
    }
    return columnConfig;
  };

  const getSalaryAdvanceFields = () => {
    return (
      <>
        {salaryAdvanceFormFields &&
          salaryAdvanceFormFields.map((obj, index) => {
            switch (obj.id) {
                case "amount":
                case "installmentAmount":
                    return (
                        <>
                          <div
                            className="column p-h-l"
                            style={{
                              width: `${obj.width ? `${obj.width}%` : "50%"}`,
                            }}
                            key={obj.id}
                          >
                            <MaskInput
                                setRef={(ref) => ERF.ADD_EMPLOYEE[obj.id] = ref}
                                showMask={mask}
                                unmaskLen={0}
                                autoFocus={index === 0 && props.autoFocus === true}
                                className={"pt-s pb-xs"}
                                title={obj.name}
                                placeholder={obj.name}
                                icon={obj.icon}
                                type={obj.type}
                                direction={obj.direction}
                                value={PermissionUtils.showMaskedAmount(salaryAdvanceDefaultValues[obj.columnCode] || 0)}
                                required={obj.required}
                                readOnly={obj.readOnly || 
                                  !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) ||
                                  !hasPermission
                                }
                                canValidate={false}
                                onChange={(value) => {
                                    onChange(value, index, obj, obj.name, "Salary Advance");
                                }}
                            />
                            {obj.hasError && (
                              <DKLabel
                                className="pl-s unselectable fs-s text-red"
                                style={{
                                  whiteSpace: "nowrap",
                                }}
                                text={obj.errMsg}
                              />
                            )}
                          </div>
                        </>
                      );
                    break;
                default:
                    return (
                      <>
                        <div
                          className="column p-h-l"
                          style={{
                            width: `${obj.width ? `${obj.width}%` : "50%"}`,
                          }}
                          key={obj.id}
                        >
                          <DKInput
                            autoFocus={index === 0 && props.autoFocus === true}
                            className={"pt-s pb-xs"}
                            icon={obj.icon}
                            title={obj.name}
                            placeholder={obj.name}
                            value={salaryAdvanceDefaultValues[obj.columnCode]}
                            options={obj.options}
                            type={obj.type}
                            hasError={obj.hasError}
                            errorMsg={obj.errorMsg}
                            labelClassName=" text-align-left "
                            canValidate={false}
                            onChange={(value) => {
                              onChange(value, index, obj, obj.name, "Salary Advance");
                            }}
                            direction={obj.direction}
                            required={obj.required}
                            readOnly={
                              (obj.columnCode != "installmentAmount" && !isAdmin && !hasPermission)
                                ? true
                                : obj.readOnly
                            }
                          />
                          {obj.hasError && (
                            <DKLabel
                              className="pl-s unselectable fs-s text-red"
                              style={{
                                whiteSpace: "nowrap",
                              }}
                              text={obj.errMsg}
                            />
                          )}
                        </div>
                      </>
                    );
            }
          })}
      </>
    );
  };
  const getTooltip = (obj) => {
    let value = componentDefaultValuesVariable[obj.id]
      ? componentDefaultValuesVariable[obj.id]["variableValue"]
      : 0;
    switch (obj.variableName) {
      case "Percentage of CTC":
        return `${value} % of CTC`;
      case "Percentage of Basic":
        return `${value} % of basic`;
      case "Percentage of a Specific Component":
        return `${value} of Component`;
      case "Amount per day for the days worked":
        return `${value} per day for the days worked`;
      default:
        return "";
    }
  };

  const restVariableComponent = (obj, index) => {
    let id = obj.id;
    let componentsData =
      employeeDetails && employeeDetails.components
        ? employeeDetails.components
        : [];

    let selectedComponent = componentsData.filter(
      (data) => data.componentId === id
    );
    let column = deepClone(variableComponentColumnConfig);

    if (selectedComponent.length != 0) {
      let id = selectedComponent[0].componentId;
      let defaultValues = componentDefaultValuesVariable[id];
      let percentage = selectedComponent[0].componentConfig.componentPercent;
      let amount = selectedComponent[0].amount;
      defaultValues.variableValue = percentage;

      updateVariableValue(percentage, index, column, obj);
      let compensation = isIndiaCompliance()
        ? employeeDetails.ctc
        : employeeDetails.compensation;
      let monthlyCompensation = getCompensationInPerMonth(
        employeeDetails.compensationPeriod,
        compensation,
        tenantData.tenant.workWeekDetails,
        employeeDetails
      );
      updateFormulaAmountForAllComponent()
      getFixedAllowanceValue(monthlyCompensation);
      setVariableComponentColumnConfig(column);
    }
  };

  const updateComponentColumnConfig = (columnConfig, setColumnConfig) => {
    if (columnConfig) {
        const newColumnConfig = deepClone(columnConfig);
        newColumnConfig.forEach((c) => {

        });

        setColumnConfig(newColumnConfig);
    }
  }

  ////   UI Logic for Variable Component/////////////////////
  const getVariableColumnSection = () => {
    if (!TenantService.get(TENANT.IS_ADMIN)) {
        setReactRef(variableComponentColumnConfig, ERF.ADD_EMPLOYEE);
    }

    return variableComponentColumnConfig.map((obj, index) => {
      return (
        <>
          {getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL && (
            <DKLine className="bg-line-2 m-v-s" />
          )}
          <div className="row p-h-l pt-s pb-s row-responsive">
            <div className=" pr-l d-flex web-width-35 padding-empty-mobile">
              <DKInput
                autoFocus={index === 0 && props.autoFocus === true}
                className={"pt-s pb-s"}
                icon={obj.icon}
                title={t("COMPONENT")}
                placeholder={t("COMPONENT")}
                value={
                  componentDefaultValuesVariable[obj.id]
                    ? componentDefaultValuesVariable[obj.id]["component"]
                    : {}
                }
                formatter={(obj) => {
                  /** How to render a selected option in case of object **/
                  return obj.name;
                }}
                
                type={obj.type}
                hasError={obj.hasError}
                errorMsg={obj.errorMsg}
                labelClassName=" text-align-left "
                onChange={(value) => {
                  onChange(value, index, obj, "component", "Variable");
                }}
                direction={obj.direction}
                required={obj.required}
                readOnly={obj.readOnly || 
                  !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) }
                canValidate={obj.hasError}
                tooltip={{
                  content: getTooltip(obj),
                  className: "warning-tooltip-prop",
                }}
                dropdownConfig={{
                  className: "",
                  style: {},
                  allowSearch:
                    obj.options && obj.options.length > 6 ? true : false,
                  searchableKey: "name",
                  data: obj.options,
                  renderer: (index, obj) => {
                    /** How to render value in Dropdown in case of object **/
                    return <DKLabel text={`${obj.name}`} />;
                  },
                  onSelect: (index, obj) => {},
                  button: PermissionUtils.hasAccess(MODULE.EARNINGS_AND_DEDUCTIONS,[ACTION.CREATE]) && {
                      title: t("COMPONENT"),
                      icon: ic_add_white,
                      className: "bg-app text-white",
                      onClick: () => {
                          setShowAddVariableComponent(true);
                      }
                  }
                }}
              />
            </div>
            <div
              className="d-flex p-h-l align-items-center web-width-30 padding-empty-mobile"
              // style={{ marginTop: "auto" }}
            >
              <div className="parent-width">
                <DKInput
                  ref={ERF.ADD_EMPLOYEE[obj.id]}
                  autoFocus={index === 0 && props.autoFocus === true}
                  title={obj.variableName || " "}
                  icon={obj.icon}
                  placeholder={obj.name}
                  value={PermissionUtils.showMaskedAmount(componentDefaultValuesVariable[obj.id]?.variableValue || 0)}
                  options={obj.options}
                  type={"number"}
                  hasError={obj.hasErrorVariable}
                  errorMsg={obj.errMsgVariable}
                  labelClassName=" text-align-left "
                  onChange={(value) => {
                    onChange(value, index, obj, "variableValue", "Variable");
                  }}
                  direction={obj.direction}
                  required={obj.required}
                  readOnly={
                    (obj.name === CONSTANTS.FIXED_ALLOWANCE || (!isAdmin && !hasPermission)) 
                      ? true
                      : !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)
                  }
                  canValidate={obj.hasError}
                  tooltip={{
                    content: obj.hasInfoText,
                    className: "warning-tooltip-prop",
                  }}
                />
              </div>
              {obj.hasErrorVariable && (
                <div
                  style={{
                    marginLeft: "-24px",
                    zIndex: "2",
                    paddingTop: "26px",
                  }}
                >
                  <DKTooltipWrapper
                    content={obj.errMsgVariable}
                    tooltipClassName="warning-tooltip-prop "
                  >
                    <DKIcon src={ic_info_error} className="ic-s" />
                  </DKTooltipWrapper>
                </div>
              )}
            </div>
            <div className="column p-h-s web-width-15 padding-empty-mobile">
              <DKLabel text="Amount *" className="padding-top-mobile" />
              <span
                className="fs-l fw-m"
                style={{
                  paddingTop: `${
                    getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL
                      ? "5px"
                      : "15px"
                  }`,
                }}
              >
                {componentDefaultValuesVariable[obj.id] ?
                    PermissionUtils.showMaskedAmount(MaskInputUtil.getMaskedNumber(mask, componentDefaultValuesVariable[obj.id]["amount"]))
                    : 0
                }
              </span>
            </div>

            <div className="column p-h-s web-width-15 padding-empty-mobile">
              <DKLabel text="Frequency" className="padding-top-mobile" />
              <span
                className=""
                style={{
                  paddingTop: `${
                    getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL
                      ? "5px"
                      : "15px"
                  }`,
                }}
              >
                {componentDefaultValuesVariable[obj.id]
                  ? componentDefaultValuesVariable[obj.id]["frequency"]
                  : ""}
              </span>
            </div>
            <div
              className="column p-h-s padding-empty-mobile"
              style={{
                width: "10%",
              }}
            >
              <div className="row mb-xl">
                {false && obj.isEdit && (
                  <div onClick={() => onEditFixedComponent(index, obj)}>
                    <DKIcon src={ic_edit} className="cursor-hand" />
                  </div>
                )}
                {hasPermission && obj.isDelete && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) && (
                  <div
                    onClick={() => onDeleteVariableComponent(index, obj)}
                    style={{
                      position: "relative",
                      top: `${
                        getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL
                          ? "10px"
                          : "25px"
                      }`,
                    }}
                  >
                    <DKIcon src={ic_delete} className="cursor-hand" />
                  </div>
                )}
              </div>
            </div>
          </div>
          {(obj.name == CONSTANTS.BASIC || obj.name == CONSTANTS.HRA) &&
            obj.defaultComponent && (
              <div className="row p-h-l">
                <span
                  className="row padding-bottom-mobile"
                  style={{ width: "80%" }}
                >
                  <DKIcon src={ic_info_warning} className="ic-s mr-r" />
                  <DKLabel
                    className="mt-xs"
                    text=" Editing this value will be applicable to this employee, which you may set to default by clicking "
                  />
                </span>
                <DKButton
                  title="Reset"
                  className="fw-m app-text"
                  onClick={() => {
                    if(!hasPermission) {
                      return
                    }
                    restVariableComponent(obj, index);
                  }}
                />
              </div>
            )}
        </>
      );
    });
  };
  /*
  // *********Fixed Component Render****************
  */
  const getFixedColumnSection = () => {
    return fixedComponentColumnConfig.map((obj, index) => {
      return (
        <>
          {getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL && (
            <DKLine className="bg-line-2 m-v-s" />
          )}
          <div
            className="row p-h-l p-v-s row-responsive"
            // style={{ alignItems: "baseline" }}
          >
            {/* Column 1 Component Dropdown */}
            <div className="column pr-l web-width-40 padding-empty-mobile">
              <DKInput
                autoFocus={index === 0 && props.autoFocus === true}
                className={"pt-s pb-xs"}
                icon={obj.icon}
                title={t("COMPONENT")}
                placeholder={t("COMPONENT")}
                value={
                  componentDefaultValues[obj.id]
                    ? componentDefaultValues[obj.id]["component"]
                    : {}
                }
                formatter={(obj) => {
                  /** How to render a selected option in case of object **/
                  return obj.name;
                }}
                options={obj.options}
                type={obj.type}
                hasError={obj.hasError}
                errorMsg={obj.errorMsg}
                labelClassName=" text-align-left "
                onChange={(value) => {
                  onChange(value, index, obj, "component", "Fixed");
                }}
                direction={obj.direction}
                required={obj.required}
                readOnly={obj.readOnly || 
                  !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) 
                }
                canValidate={obj.hasError}
                dropdownConfig={{
                  className: "",
                  style: {},
                  allowSearch:
                    obj.options && obj.options.length > 6 ? true : false,
                  searchableKey: "name",
                  data: obj.options,
                  renderer: (index, obj) => {
                    /** How to render value in Dropdown in case of object **/
                    return <DKLabel text={`${obj.name}`} />;
                  },
                  onSelect: (index, obj) => {},
                  button: PermissionUtils.hasAccess(MODULE.EARNINGS_AND_DEDUCTIONS,[ACTION.CREATE]) && {
                      title: t("COMPONENT"),
                      icon: ic_add_white,
                      className: "bg-app text-white",
                      onClick: () => {
                          setShowAddFixedComponent(true);
                      }
                  }
                }}
              />
            </div>
            {/* column 2 Amount */}
            <div className="d-flex p-h-l web-width-30 padding-empty-mobile">
              <div className="parent-width">
                <MaskInput
                    setRef={(ref) => ERF.ADD_EMPLOYEE[obj.id] = ref}
                    showMask={mask}
                    unmaskLen={0}
                    autoFocus={index === 0 && props.autoFocus === true}
                    title={"Amount"}
                    placeholder={"Amount"}
                    icon={obj.icon}
                    direction={obj.direction}
                    value={PermissionUtils.showMaskedAmount(componentDefaultValues[obj.id]?.amount || 0)}
                    required={obj.required}
                    readOnly={
                        obj.name === CONSTANTS.FIXED_ALLOWANCE || (!isAdmin && !hasPermission)|| componentDefaultValues[obj.id]?.component?.isFormula
                        ? true
                        : !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)
                    }
                    canValidate={obj.hasError}
                    onChange={(value) => {
                        onChange(value, index, obj, "amount", "Fixed");
                    }}
                    tooltip={{
                      content: getTooptipText(componentDefaultValues,obj),
                      className: "warning-tooltip-prop",
                    }}
                />
              </div>
              {obj.hasErrorAmount && (
                <div
                  style={{
                    marginLeft: "-24px",
                    zIndex: "2",
                    paddingTop: "40px",
                  }}
                >
                  <DKTooltipWrapper
                    content={obj.errMsg}
                    tooltipClassName="warning-tooltip-prop "
                  >
                    <DKIcon src={ic_info_error} className="ic-s" />
                  </DKTooltipWrapper>
                </div>
              )}
            </div>

            {/* Column 3 Frequency */}
            <div className="column p-h-s web-width-15 padding-empty-mobile">
              <DKLabel text="Frequency" className="padding-top-mobile" />
              <span
                className=""
                style={{
                  paddingTop: `${
                    getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL
                      ? "5px"
                      : "15px"
                  }`,
                }}
              >
                {componentDefaultValues[obj.id]
                  ? componentDefaultValues[obj.id]["frequency"]
                  : ""}
              </span>
            </div>

            {/* column 4 Delete button */}
            <div
              className="column p-h-s padding-empty-mobile"
              style={{
                width: "15%",
              }}
            >
              <div className="row mb-xl">
                {false && obj.isEdit && (
                  <div onClick={() => onEditFixedComponent(index, obj)}>
                    <DKIcon src={ic_edit} className="cursor-hand" />
                  </div>
                )}
                {obj.isDelete && hasPermission && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) && (
                  <div
                    onClick={() => onDeleteFixedComponent(index, obj)}
                    style={{
                      position: "relative",
                      top: `${
                        getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL
                          ? "10px"
                          : "25px"
                      }`,
                    }}
                  >
                    <DKIcon src={ic_delete} className="cursor-hand" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      );
    });
  };
  const getTooptipText = (componentDefaultValues,obj) => {
    
    let tooltipText = '';
    let formulaObj = componentDefaultValues[obj.id]; 
    if(formulaObj?.component?.formula) {
      tooltipText = `Amount is calculated on formula: ${formulaObj.component.formula}`
      if(!Utility.isEmpty(formulaObj.component.formulaConfig)) {
        tooltipText += `<br>Where used`
        tooltipText += formulaObj.component.formulaConfig.map(config=>{
          let componentObj = componentMeta.components.find(comp=>comp.id == config.componentId)
          return `<br>${config.index} = ${config.percentage} % of ${ (componentObj && componentObj.name) ? (componentObj.name): getCapitalized(config.componentId)  }`
        })
      }
    } else {
      tooltipText = obj.tooltipText;
    }
    return tooltipText;
  }

  const getBenefitColumnSection = () => {
    if (!TenantService.get(TENANT.IS_ADMIN)) {
        benefitComponentColumnConfig.forEach((f) => {
            if (!ERF.ADD_EMPLOYEE[`${f.id}-employee`]) {
                ERF.ADD_EMPLOYEE[`${f.id}-employee`] = React.createRef();
            }

            if (!ERF.ADD_EMPLOYEE[`${f.id}-employer`]) {
                ERF.ADD_EMPLOYEE[`${f.id}-employer`] = React.createRef();
            }
        });
    }

    return benefitComponentColumnConfig.map((obj, index) => {
      return (
        <>
          {getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL && (
            <DKLine className="bg-line-2 m-v-s" />
          )}
          <div
            className="row p-h-l p-v-s row-responsive"
            // style={{ alignItems: "baseline" }}
          >
            <div className="column pr-l web-width-40 padding-empty-mobile">
              <DKInput
                autoFocus={index === 0 && props.autoFocus === true}
                className={"pt-s pb-xs"}
                icon={obj.icon}
                title={"Benefit"}
                placeholder={"Benefit"}
                value={
                  componentDefaultValuesBenefit[obj.id]
                    ? componentDefaultValuesBenefit[obj.id]["component"]
                    : {}
                }
                formatter={(obj) => {
                  /** How to render a selected option in case of object **/
                  return obj.name;
                }}
                options={obj.options}
                type={obj.type}
                hasError={obj.hasError}
                errorMsg={obj.errorMsg}
                labelClassName=" text-align-left "
                onChange={(value) => {
                  onChange(value, index, obj, "component", "benefit");
                }}
                direction={obj.direction}
                required={obj.required}
                readOnly={obj.readonly || 
                  !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)
                }
                canValidate={obj.hasError}
                dropdownConfig={{
                  className: "",
                  style: {},
                  allowSearch:
                    obj.options && obj.options.length > 6 ? true : false,
                  searchableKey: "name",
                  data: obj.options,
                  renderer: (index, obj) => {
                    /** How to render value in Dropdown in case of object **/
                    return <DKLabel text={`${obj.name}`} />;
                  },
                  onSelect: (index, obj) => {},
                  button: PermissionUtils.hasAccess(MODULE.BENEFITS,[ACTION.CREATE]) && {
                      title: "Benefit",
                      icon: ic_add_white,
                      className: "bg-app text-white",
                      onClick: () => {
                          setShowAddBenefits(true);
                      }
                  }
                }}
              />
            </div>
            <div
              className="d-flex p-h-l web-width-30 padding-empty-mobile"
            >
              <div className="parent-width">
                <MaskInput
                    setRef={(ref) => ERF.ADD_EMPLOYEE[`${obj.id}-employee`] = ref}
                    showMask={mask}
                    unmaskLen={0}
                    autoFocus={index === 0 && props.autoFocus === true}
                    className={"pt-s pb-xs"}
                    title={"Employee Cost"}
                    placeholder={"Employee Cost"}
                    icon={obj.icon}
                    type={"number"}
                    direction={obj.direction}
                    value={PermissionUtils.showMaskedAmount(componentDefaultValuesBenefit[obj.id]?.employeeDeductionAmount)}
                    required={obj.required}
                    readOnly={obj.name === CONSTANTS.FIXED_ALLOWANCE || !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)}
                    canValidate={obj.hasError}
                    onChange={(value) => {
                        onChange(value, index, obj, "employeeCost", "benefit");
                    }}
                />
                {obj.hasErrorEmployeeAmount && (
                  <DKLabel
                    className="pl-s fs-s unselectable text-red"
                    style={{
                      whiteSpace: "nowrap",
                    }}
                    text={obj.errMsg}
                  />
                )}
              </div>
            </div>
            <div
              className="d-flex p-h-l web-width-30 padding-empty-mobile"
            >
              <div className="parent-width">
                <MaskInput
                    setRef={(ref) => ERF.ADD_EMPLOYEE[`${obj.id}-employer`] = ref}
                    showMask={mask}
                    unmaskLen={0}
                    autoFocus={index === 0 && props.autoFocus === true}
                    className={"pt-s pb-xs"}
                    title={"Employer Cost"}
                    placeholder={"Employer Cost"}
                    icon={obj.icon}
                    type={"number"}
                    direction={obj.direction}
                    value={PermissionUtils.showMaskedAmount(componentDefaultValuesBenefit[obj.id]?.employerDeductionAmount)}
                    required={obj.required}
                    readOnly={obj.name === CONSTANTS.FIXED_ALLOWANCE || !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)}
                    canValidate={obj.hasError}
                    onChange={(value) => {
                        onChange(value, index, obj, "employerCost", "benefit");
                    }}
                />
                {obj.hasErrorEmployerAmount && (
                  <DKLabel
                    className="pl-s fs-s unselectable text-red"
                    style={{
                      whiteSpace: "nowrap",
                    }}
                    text={obj.errMsg}
                  />
                )}
              </div>
            </div>
            <div
              className="column p-h-s padding-empty-mobile"
              style={{
                width: "10%",
              }}
            >
              <div className="row mb-xl">
                {false && obj.isEdit && (
                  <div onClick={() => onEditFixedComponent(index, obj)}>
                    <DKIcon src={ic_edit} className="cursor-hand" />
                  </div>
                )}
                {hasPermission && obj.isDelete && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) && (
                  <div
                    onClick={() => onDeleteBenefitComponent(index, obj)}
                    style={{
                      position: "relative",
                      top: `${
                        getViewportSize() === VIEWPORT_SIZES.EXTRA_SMALL
                          ? "10px"
                          : "25px"
                      }`,
                    }}
                  >
                    <DKIcon src={ic_delete} className="cursor-hand" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      );
    });
  };
  const removeAllFixedAssignGroupComponent = (
    oldFixedComponentColumnConfig,
    fixedComponentColumnConfig
  ) => {
    let filterList = oldFixedComponentColumnConfig.filter(
      (res) => !res.defaultComponent
    );
    filterList.forEach((obj) => {
      let index = oldFixedComponentColumnConfig.findIndex(
        (comp) => comp.id == obj.id
      );
      onDeleteOldGroupComponent(index, oldFixedComponentColumnConfig, obj);
    });
  };
  const removeAllVariableAssignGroupComponent = (
    oldVariableComponentColumnconfig,
    variableComponentColumnConfig
  ) => {
    let filterList = oldVariableComponentColumnconfig.filter(
      (res) => !res.defaultComponent
    );
    filterList.forEach((obj) => {
      let index = oldVariableComponentColumnconfig.findIndex(
        (comp) => comp.id == obj.id
      );
      onDeleteGroupVariableComponent(
        index,
        oldVariableComponentColumnconfig,
        obj
      );
    });
  };
  const removeAllBenefitAssignGroupComponent = (
    oldBenefitComponentColumnconfig,
    benefitComponentColumnConfig
  ) => {
    let filterList = oldBenefitComponentColumnconfig.filter(
      (res) => !res.defaultComponent
    );
    filterList.forEach((obj) => {
      let index = oldBenefitComponentColumnconfig.findIndex(
        (comp) => comp.id == obj.id
      );
      onDeleteOldBenefitComponent(index, oldBenefitComponentColumnconfig, obj);
    });
  };
  const assignColumnConfigForBenefitComponent = (
    oldBenefitComponentColumnConfig
  ) => {
    let columnConfig = oldBenefitComponentColumnConfig;
    let isValid = benefitComponentSelected(columnConfig);
    if (isValid) {
      let details = getDefaultColumnForBenefit(columnConfig);
      columnConfig.push(details);
    } else {
    }
  };
  const assignFixedColumnConfig = (columnConfig) => {
    let isValid = componentSelected(columnConfig);
    if (isValid) {
      let details = getDefaultColumnForFixed(columnConfig);
      columnConfig.push(details);
    }
  };
  const assignVariableColumnConfig = (columnConfig) => {
    let isValid = variableComponentSelected(columnConfig);
    let details = getDefaultColumnForVariable(columnConfig);
    columnConfig.push(details);
  };

  const onComponentGroupChange = (selectedGroup) => {
    let fixedCmpMap = new Map();
    let varCmpMap = new Map();
    fixedComponents.forEach(component => {
      fixedCmpMap.set(component.id, component)
    });
    variableComponent.forEach(component => {
      varCmpMap.set(component.id, component)
    });
    selectedGroup.fixedComponents.forEach(item => {
      let cmp = fixedCmpMap.get(item.componentId);
      if (cmp != undefined) {
        item.employees = cmp.employees;
        item.isForAllEmployee = cmp.isForAllEmployee;
      }
    });
    selectedGroup.variableComponents.forEach(item => {
      let cmp = varCmpMap.get(item.componentId);
      if (cmp != undefined) {
         item.employees = cmp.employees;
         item.isForAllEmployee = cmp.isForAllEmployee
      }
    });
    selectedGroup.fixedComponents = filterRemainingOptionByEmployeeApplicability(selectedGroup.fixedComponents)
    selectedGroup.variableComponents = filterRemainingOptionByEmployeeApplicability(selectedGroup.variableComponents)
    let oldFixedComponentColumnConfig = deepClone(fixedComponentColumnConfig);

    removeAllFixedAssignGroupComponent(
      oldFixedComponentColumnConfig,
      fixedComponentColumnConfig
    );

    let oldVariableComponentColumnConfig = deepClone(
      variableComponentColumnConfig
    );
    if (selectedGroup.fixedComponents) {
      selectedGroup.fixedComponents.forEach((ele, ind) => {
        assignFixedColumnConfig(oldFixedComponentColumnConfig);
        let selectedOption = fixedRemainingDefaultOptions.findIndex(
          (res) => ele.name == res.name
        );
        oldFixedComponentColumnConfig[
          oldFixedComponentColumnConfig.length - 1
        ].defaultOptions[selectedOption].amount = ele.amount;
        onChangeSelectedGroup(
          oldFixedComponentColumnConfig[
            oldFixedComponentColumnConfig.length - 1
          ].defaultOptions[selectedOption],
          oldFixedComponentColumnConfig.length - 1,
          oldFixedComponentColumnConfig[
            oldFixedComponentColumnConfig.length - 1
          ],
          "component",
          "Fixed",
          oldFixedComponentColumnConfig,
          oldVariableComponentColumnConfig,
          null
        );
      });
    }
    

    // Variable *******
    oldVariableComponentColumnConfig = deepClone(variableComponentColumnConfig);
    removeAllVariableAssignGroupComponent(
      oldVariableComponentColumnConfig,
      variableComponentColumnConfig
    );

    if (selectedGroup.variableComponents) {
      selectedGroup.variableComponents.forEach((ele, ind) => {
        assignVariableColumnConfig(oldVariableComponentColumnConfig);
        let selectedOption = variableRemainingDefaultOptions.findIndex(
          (res) => ele.componentId == res.id
        );
        onChangeSelectedGroup(
          oldVariableComponentColumnConfig[
            oldVariableComponentColumnConfig.length - 1
          ].defaultOptions[selectedOption],
          oldVariableComponentColumnConfig.length - 1,
          oldVariableComponentColumnConfig[
            oldVariableComponentColumnConfig.length - 1
          ],
          "component",
          "Variable",
          oldFixedComponentColumnConfig,
          oldVariableComponentColumnConfig,
          null
        );
      });
    }

    if (isUSCompliance()) {
      let oldBenefitComponentColumnConfig = deepClone(
        benefitComponentColumnConfig
      );
      removeAllBenefitAssignGroupComponent(
        oldBenefitComponentColumnConfig,
        benefitComponentColumnConfig
      );
      if (selectedGroup.benefits) {
        selectedGroup.benefits.forEach((ele, ind) => {
          assignColumnConfigForBenefitComponent(
            oldBenefitComponentColumnConfig
          );
          let selectedOption = benefitRemainingDefaultOptions.findIndex(
            (res) => ele.benefitId == res.benefitId
          );
          onChangeSelectedGroup(
            benefitRemainingDefaultOptions[selectedOption],
            oldBenefitComponentColumnConfig.length - 1,
            oldBenefitComponentColumnConfig[
              oldBenefitComponentColumnConfig.length - 1
            ],
            "component",
            "benefit",
            oldFixedComponentColumnConfig,
            oldVariableComponentColumnConfig,
            oldBenefitComponentColumnConfig
          );
        });
      }

      setBenefitComponentColumnConfig(oldBenefitComponentColumnConfig);
    }
    setSelectComponentGroup(selectedGroup);
    setFixedComponentColumnConfig(oldFixedComponentColumnConfig);
    setVariableComponentColumnConfig(oldVariableComponentColumnConfig);
  };

  const updateSection = (sectionToUpdate) => {
    const customSectionsToUpdate = [...customSections];
    const idx = customSectionsToUpdate.findIndex((s) => s.name === sectionToUpdate.name);
    if (idx !== -1) {
      customSectionsToUpdate[idx] = sectionToUpdate;
    }

    const customSectionFieldValues = CustomSectionManager.getCustomSectionFields(customSectionsToUpdate);
    setCustomSectionFieldValues(customSectionFieldValues);
    setCustomSections(customSectionsToUpdate);
  }

  const getComponentGroupField = () => {
    return (
      <div className="mt-m parent-width bg-white border-radius-s card-shadow">
        <div className="p-h-l pt-m pb-xl">
            <div className="row justify-content-between mb-m">
                <DKLabel
                    className="fw-m fs-l"
                    text={t("COMPONENT_TEMPLATE")}
                />
            </div>
            <div className="row row-responsive">
                <div className="web-width-40" id="component-group-dropdown">
                    <DKInput
                        title=""
                        value={selectComponentGroup}
                        type={INPUT_TYPE.DROPDOWN}
                        showError={true}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        readOnly={(!isAdmin && !hasPermission) || 
                          !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)
                        }
                        required={false}
                        formatter={(obj) => {
                            return obj.name;
                        }}
                        canValidate={false}
                        dropdownConfig={{
                            className: "",
                            style: {},
                            allowSearch: componentGroup.length > 0 ? true : false,
                            searchableKey: undefined,
                            data: componentGroup,
                            renderer: (index, obj) => {
                                return <DKLabel text={`${obj.name}`} />;
                            },
                            onSelect: (ind, value) => {
                                oldSelectComponentGroup = selectComponentGroup;
                                showAlert(
                                    "Confirm",
                                    "Are you sure you want to replace the existing components with the ones in the template group?<br>(Default components will be unaffected)",
                                    [
                                        {
                                            title: "Yes",
                                            className: "bg-app text-white mr-r",
                                            onClick: () => onComponentGroupChange(value),
                                        },
                                        {
                                            title: "No",
                                            className: "bg-gray1 border-m"
                                        }
                                    ]
                                );
                            },
                            button: PermissionUtils.hasAccess(MODULE.EARNING_DEDUCTION_TEMPLETE,[ACTION.CREATE]) && {
                                title: t("COMPONENT_TEMPLATE"),
                                icon: ic_add_white,
                                className: "bg-app text-white",
                                onClick: () => {
                                    setShowAddComponentGroup(true);
                                }
                            }
                        }}
                        onChange={(value) => {}}
                    />
                </div>
            </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="d-flex row-responsive">
        <div className="web-width-70 mb-l">
          {showAddComponentGroup &&
            <div className="transparent-background">
                <AddComponentGroupPopup
                    onClose={(refresh) => {
                        setShowAddComponentGroup(false);
                        if (refresh) {
                            getComponentGroups();
                        }
                    }}
                />
            </div>
          }
          {showAddFixedComponent && 
            <ComponentAddPopup
                isVariable={false}
                employeeList={employeeListState}
                onClose={async(refresh) => {
                    await dispatch(fetchComponent());
                    setShowAddFixedComponent(false);
                }}
            />
          }
          {showAddVariableComponent && 
            <ComponentAddPopup
                isVariable={true}
                employeeList={employeeListState}
                onClose={async(refresh) => {
                    setShowAddVariableComponent(false);
                    if (refresh) {
                        await dispatch(fetchComponent());                      
                        updateComponentColumnConfig(fixedComponentColumnConfig, setFixedComponentColumnConfig);
                    }
                }}
            />
          }
          {showAddBenefits &&
            <div className="transparent-background">
                <AddEditBenefitsPopup
                    onClose={() => setShowAddBenefits(false) }
                    data={{}}
                    loadBenefit={async() => {
                      await dispatch(fetchTotalBenefits());
                    }}
                />
            </div>
          }
          {getComponentGroupField()}
          <div className="mt-xl pb-m parent-width bg-white border-radius-s card-shadow">
            {!Utility.isEmpty(fixedComponents) && (
              <>
                <DKLabel
                  text={t("FIXED_COMPONENTS")}
                  className="fw-m fs-l mb-r pt-l p-h-l "
                />
                {/* Fixed components dropdown render */}
                <div>
                  {!Utility.isEmpty(fixedComponentColumnConfig) &&
                    fixedComponentColumnConfig.length > 0 &&
                    getFixedColumnSection()}
                </div>

                {/*Button Add / assign Earning/deduction component */}

                {hasPermission && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) &&
                  fixedComponents &&
                  fixedComponents.length != 0 && (
                    <div className="row p-v-l p-h-s">
                      <DKButton
                        title={t("ASSIGN_COMPONENT")}
                        onClick={() => addColumnConfigForFixedComponent()}
                        className="bg-app text-white ml-r"
                        icon={ic_add_white}
                      ></DKButton>
                    </div>
                )}
                {hasPermission && !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) && fixedComponentColumnConfig?.length === 0 &&
                    <div className="p-v-xxl p-h-l text-align-center">
                        <img class="ic-xxl" src={zeroState} />
                        <h6 class="m-0 d-flex justify-content-center fs-l fw-r">
                            {t("Access Denied")}
                        </h6>
                    </div>
                }

                {/* Salary Advance button Toggle */}
                {hasPermission && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) &&
                    <div className="d-flex p-h-l p-v-s" style={{ pointerEvents: hasPermission ? "" : "none" }}>
                        <Toggle
                            className="border-n"
                            isOn={isSalaryAdvance}
                            onChange={() => enableSalaryAdvance()}
                        />
                        <DKLabel
                            className="m-v-xs ml-s mr-l"
                            text={"Salary Advance"}
                        />
                    </div>
                }
                {/* /////// */}
              </>
            )}
            {Utility.isEmpty(fixedComponents) && (
              <>
                <div className="mt-xl p-v-xxl p-h-l text-align-center">
                  <img class="ic-xxl" src={zeroState} />
                  <h6 class="m-0 d-flex justify-content-center fs-l fw-r">
                    {t("NO_FIXED_COMP_AVAILABLE")}
                  </h6>
                  {(hasPermission && PermissionUtils.hasAccess(MODULE.EARNINGS_AND_DEDUCTIONS,[ACTION.CREATE])) && <div className="d-flex justify-content-center mt-s">
                    <DKButton
                      title={t("COMPONENT")}
                      icon={ic_add_white}
                      className="bg-app text-white"
                      onClick={() => {
                        setShowAddFixedComponent(true);
                      }}
                    />
                  </div>
                  }
                </div>
              </>
            )}
            {isSalaryAdvance && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
                className=" parent-width pb-xl"
              >
                {getSalaryAdvanceFields()}
                {salaryAdvanceDefaultValues[COLUMN_CODES.INSTALLMENTS] > 0 && (
                  <div className="p-v-s p-h-l">
                    <span>Loan will be paid in remaining:</span>
                    <span className="fw-m">
                      {`${
                        salaryAdvanceDefaultValues[COLUMN_CODES.INSTALLMENTS]
                      } Installments`}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="mt-xl pb-m parent-width bg-white border-radius-s card-shadow">
            {!Utility.isEmpty(variableComponent) && (
              <>
                <DKLabel
                  text={t("VARIABLE_COMPONENTS")}
                  className="fw-m fs-l mb-r pt-l p-h-l"
                />
                <div>
                  {!Utility.isEmpty(variableComponentColumnConfig) &&
                    variableComponentColumnConfig.length > 0 &&
                    getVariableColumnSection()}
                </div>
                {hasPermission && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) &&
                  variableComponent &&
                    variableComponent.length != 0 && (
                    <div className="row p-v-l p-h-s">
                      <DKButton
                        title={t("ASSIGN_COMPONENT")}
                        onClick={() => addColumnConfigForVariableComponent()}
                        className="bg-app text-white ml-r"
                        icon={ic_add_white}
                      ></DKButton>
                    </div>
                )}
                {hasPermission && !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) && variableComponentColumnConfig?.length === 0 &&
                    <div className="p-v-xxl p-h-l text-align-center">
                        <img class="ic-xxl" src={zeroState} />
                        <h6 class="m-0 d-flex justify-content-center fs-l fw-r">
                            {t("Access Denied")}
                        </h6>
                    </div>
                }
              </>
            )}
            {Utility.isEmpty(variableComponent) && (
              <>
                <div className="p-v-xxl p-h-l">
                  <img
                    class="ic-xxl align-items-center-compo"
                    src={zeroState}
                  />
                  <h6 class="m-0 d-flex justify-content-center fs-l fw-r">
                    {t("NO_VARIABLE_COMP_AVAILABLE")}
                  </h6>
                  {(hasPermission && PermissionUtils.hasAccess(MODULE.EARNINGS_AND_DEDUCTIONS,[ACTION.CREATE])) && <div className="d-flex justify-content-center mt-s">
                    <DKButton
                      title={t("COMPONENT")}
                      icon={ic_add_white}
                      className="bg-app text-white"
                      onClick={() => {
                        setShowAddVariableComponent(true);
                      }}
                    />
                  </div>
                  }
                </div>
              </>
            )}
          </div>
          {isBenefitEnabled() && (
            <div className="mt-xl pb-m parent-width bg-white border-radius-s card-shadow">
              {!Utility.isEmpty(benefitComponent) && (
                <>
                  <DKLabel
                    text="Benefits"
                    className="fw-m fs-l mb-r pt-l p-h-l"
                  />
                  <div>
                    {!Utility.isEmpty(benefitComponentColumnConfig) &&
                      benefitComponentColumnConfig.length > 0 &&
                      getBenefitColumnSection()}
                  </div>
                  {hasPermission && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) &&
                    benefitComponent &&
                    benefitComponentColumnConfig.length !=
                      benefitComponent.length && (
                      <div className="row p-v-l p-h-s">
                        <DKButton
                          title="Add Benefit"
                          onClick={() => addColumnConfigForBenefitComponent()}
                          className="bg-app text-white ml-r"
                          icon={ic_add_white}
                        ></DKButton>
                      </div>
                    )}

                    {hasPermission && !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) && benefitComponentColumnConfig?.length === 0 &&
                        <div className="p-v-xxl p-h-l text-align-center">
                            <img class="ic-xxl" src={zeroState} />
                            <h6 class="m-0 d-flex justify-content-center fs-l fw-r">
                                {t("Access Denied")}
                            </h6>
                        </div>
                    }
                </>
              )}
              {Utility.isEmpty(benefitComponent) && (
                <>
                  <div className="mt-xl p-v-xxl p-h-l">
                    <img
                      class="ic-xxl align-items-center-compo"
                      src={zeroState}
                    />
                    <h6 class="m-0 d-flex justify-content-center fs-l fw-r">
                      No Benefits Available
                    </h6>
                    {PermissionUtils.hasAccess(MODULE.BENEFITS,[ACTION.CREATE]) && <div className="d-flex justify-content-center mt-s">
                      <DKButton
                        title={t("Benefit")}
                        icon={ic_add_white}
                        className="bg-app text-white"
                        onClick={() => {
                          setShowAddBenefits(true);
                        }}
                      />
                    </div>
                    }
                  </div>
                </>
              )}
            </div>
          )}
          {Array.isArray(customSections) && (
            <Fragment>
              {EmployeeConfigService.getNonDefaultSections(customSections).map((section) => {
                return (
                  <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
                    <DKLabel text={section.title} className="fw-m fs-l mb-m pt-l p-h-l" />
                    <DKLine className="bg-line-2" />
                    <div className="parent-width parent-width pb-m pt-s" style={{ display: "flex", flexWrap: "wrap" }}>
                      <EmployeeCustomSection
                        section={section}
                        updateSection={(sectionToUpdate) => {
                          updateSection(sectionToUpdate);
                        }}
                      />
                    </div>
                  </div>
                )
              })}
            </Fragment>
          )}
        </div>

        <div className="pt-l pl-l web-width-30 padding-empty-mobile padding-top-mobile">
          {!hideCompensation && <RightPanel
            mask={mask}
            data={deepClone(employeeDetails)}
            components={{
              componentDefaultValues: componentDefaultValues,
              componentDefaultValuesVariable: componentDefaultValuesVariable,
              componentDefaultValuesBenefit: componentDefaultValuesBenefit,
              fixedComponentColumnConfig: fixedComponentColumnConfig,
              variableComponentColumnConfig: variableComponentColumnConfig,
              benefitComponentColumnConfig: benefitComponentColumnConfig,
            }}
            stepIndex={1}
            userId={employeeDetails.userId}
          />}
        </div>
      </div>
    </>
  );
});

export default ComponentDetails;
